/**
 * Swiper 4.5.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: August 20, 2019
 */
!(function(e, t) {
    'object' == typeof exports && 'undefined' != typeof module
        ? (module.exports = t())
        : 'function' == typeof define && define.amd
          ? define(t)
          : ((e = e || self).Swiper = t());
})(this, function() {
    'use strict';
    var f =
            'undefined' == typeof document
                ? {
                      body: {},
                      addEventListener: function() {},
                      removeEventListener: function() {},
                      activeElement: { blur: function() {}, nodeName: '' },
                      querySelector: function() {
                          return null;
                      },
                      querySelectorAll: function() {
                          return [];
                      },
                      getElementById: function() {
                          return null;
                      },
                      createEvent: function() {
                          return { initEvent: function() {} };
                      },
                      createElement: function() {
                          return {
                              children: [],
                              childNodes: [],
                              style: {},
                              setAttribute: function() {},
                              getElementsByTagName: function() {
                                  return [];
                              }
                          };
                      },
                      location: { hash: '' }
                  }
                : document,
        Z =
            'undefined' == typeof window
                ? {
                      document: f,
                      navigator: { userAgent: '' },
                      location: {},
                      history: {},
                      CustomEvent: function() {
                          return this;
                      },
                      addEventListener: function() {},
                      removeEventListener: function() {},
                      getComputedStyle: function() {
                          return {
                              getPropertyValue: function() {
                                  return '';
                              }
                          };
                      },
                      Image: function() {},
                      Date: function() {},
                      screen: {},
                      setTimeout: function() {},
                      clearTimeout: function() {}
                  }
                : window,
        l = function(e) {
            for (var t = 0; t < e.length; t += 1) this[t] = e[t];
            return (this.length = e.length), this;
        };
    function C(e, t) {
        var i = [],
            a = 0;
        if (e && !t && e instanceof l) return e;
        if (e)
            if ('string' == typeof e) {
                var s,
                    n,
                    r = e.trim();
                if (0 <= r.indexOf('<') && 0 <= r.indexOf('>')) {
                    var o = 'div';
                    for (
                        0 === r.indexOf('<li') && (o = 'ul'), 0 === r.indexOf('<tr') &&
                            (o = 'tbody'), (0 !== r.indexOf('<td') &&
                            0 !== r.indexOf('<th')) ||
                            (o = 'tr'), 0 === r.indexOf('<tbody') && (o = 'table'), 0 ===
                            r.indexOf('<option') && (o = 'select'), (n = f.createElement(
                            o
                        )).innerHTML = r, a = 0;
                        a < n.childNodes.length;
                        a += 1
                    )
                        i.push(n.childNodes[a]);
                } else
                    for (
                        s =
                            t || '#' !== e[0] || e.match(/[ .<>:~]/)
                                ? (t || f).querySelectorAll(e.trim())
                                : [f.getElementById(e.trim().split('#')[1])], a = 0;
                        a < s.length;
                        a += 1
                    )
                        s[a] && i.push(s[a]);
            } else if (e.nodeType || e === Z || e === f) i.push(e);
            else if (0 < e.length && e[0].nodeType)
                for (a = 0; a < e.length; a += 1) i.push(e[a]);
        return new l(i);
    }
    function n(e) {
        for (var t = [], i = 0; i < e.length; i += 1)
            -1 === t.indexOf(e[i]) && t.push(e[i]);
        return t;
    }
    (C.fn = l.prototype), (C.Class = l), (C.Dom7 = l);
    var t = {
        addClass: function(e) {
            if (void 0 === e) return this;
            for (var t = e.split(' '), i = 0; i < t.length; i += 1)
                for (var a = 0; a < this.length; a += 1)
                    void 0 !== this[a] &&
                        void 0 !== this[a].classList &&
                        this[a].classList.add(t[i]);
            return this;
        },
        removeClass: function(e) {
            for (var t = e.split(' '), i = 0; i < t.length; i += 1)
                for (var a = 0; a < this.length; a += 1)
                    void 0 !== this[a] &&
                        void 0 !== this[a].classList &&
                        this[a].classList.remove(t[i]);
            return this;
        },
        hasClass: function(e) {
            return !!this[0] && this[0].classList.contains(e);
        },
        toggleClass: function(e) {
            for (var t = e.split(' '), i = 0; i < t.length; i += 1)
                for (var a = 0; a < this.length; a += 1)
                    void 0 !== this[a] &&
                        void 0 !== this[a].classList &&
                        this[a].classList.toggle(t[i]);
            return this;
        },
        attr: function(e, t) {
            var i = arguments;
            if (1 === arguments.length && 'string' == typeof e)
                return this[0] ? this[0].getAttribute(e) : void 0;
            for (var a = 0; a < this.length; a += 1)
                if (2 === i.length) this[a].setAttribute(e, t);
                else for (var s in e) (this[a][s] = e[s]), this[a].setAttribute(s, e[s]);
            return this;
        },
        removeAttr: function(e) {
            for (var t = 0; t < this.length; t += 1) this[t].removeAttribute(e);
            return this;
        },
        data: function(e, t) {
            var i;
            if (void 0 !== t) {
                for (var a = 0; a < this.length; a += 1)
                    (i = this[a]).dom7ElementDataStorage ||
                        (i.dom7ElementDataStorage = {}), (i.dom7ElementDataStorage[
                        e
                    ] = t);
                return this;
            }
            if ((i = this[0])) {
                if (i.dom7ElementDataStorage && e in i.dom7ElementDataStorage)
                    return i.dom7ElementDataStorage[e];
                var s = i.getAttribute('data-' + e);
                return s || void 0;
            }
        },
        transform: function(e) {
            for (var t = 0; t < this.length; t += 1) {
                var i = this[t].style;
                (i.webkitTransform = e), (i.transform = e);
            }
            return this;
        },
        transition: function(e) {
            'string' != typeof e && (e += 'ms');
            for (var t = 0; t < this.length; t += 1) {
                var i = this[t].style;
                (i.webkitTransitionDuration = e), (i.transitionDuration = e);
            }
            return this;
        },
        on: function() {
            for (var e, t = [], i = arguments.length; i--; ) t[i] = arguments[i];
            var a = t[0],
                n = t[1],
                r = t[2],
                s = t[3];
            function o(e) {
                var t = e.target;
                if (t) {
                    var i = e.target.dom7EventData || [];
                    if ((i.indexOf(e) < 0 && i.unshift(e), C(t).is(n))) r.apply(t, i);
                    else
                        for (var a = C(t).parents(), s = 0; s < a.length; s += 1)
                            C(a[s]).is(n) && r.apply(a[s], i);
                }
            }
            function l(e) {
                var t = (e && e.target && e.target.dom7EventData) || [];
                t.indexOf(e) < 0 && t.unshift(e), r.apply(this, t);
            }
            'function' == typeof t[1] &&
                ((a = (e = t)[0]), (r = e[1]), (s = e[2]), (n = void 0)), (s = s || !1);
            for (var d, p = a.split(' '), u = 0; u < this.length; u += 1) {
                var c = this[u];
                if (n)
                    for (d = 0; d < p.length; d += 1) {
                        var h = p[d];
                        c.dom7LiveListeners || (c.dom7LiveListeners = {}), c
                            .dom7LiveListeners[h] ||
                            (c.dom7LiveListeners[h] = []), c.dom7LiveListeners[h].push({
                            listener: r,
                            proxyListener: o
                        }), c.addEventListener(h, o, s);
                    }
                else
                    for (d = 0; d < p.length; d += 1) {
                        var v = p[d];
                        c.dom7Listeners || (c.dom7Listeners = {}), c.dom7Listeners[v] ||
                            (c.dom7Listeners[v] = []), c.dom7Listeners[v].push({
                            listener: r,
                            proxyListener: l
                        }), c.addEventListener(v, l, s);
                    }
            }
            return this;
        },
        off: function() {
            for (var e, t = [], i = arguments.length; i--; ) t[i] = arguments[i];
            var a = t[0],
                s = t[1],
                n = t[2],
                r = t[3];
            'function' == typeof t[1] &&
                ((a = (e = t)[0]), (n = e[1]), (r = e[2]), (s = void 0)), (r = r || !1);
            for (var o = a.split(' '), l = 0; l < o.length; l += 1)
                for (var d = o[l], p = 0; p < this.length; p += 1) {
                    var u = this[p],
                        c = void 0;
                    if (
                        (
                            !s && u.dom7Listeners
                                ? (c = u.dom7Listeners[d])
                                : s &&
                                  u.dom7LiveListeners &&
                                  (c = u.dom7LiveListeners[d]),
                            c && c.length
                        )
                    )
                        for (var h = c.length - 1; 0 <= h; h -= 1) {
                            var v = c[h];
                            n && v.listener === n
                                ? (
                                      u.removeEventListener(d, v.proxyListener, r),
                                      c.splice(h, 1)
                                  )
                                : n &&
                                  v.listener &&
                                  v.listener.dom7proxy &&
                                  v.listener.dom7proxy === n
                                  ? (
                                        u.removeEventListener(d, v.proxyListener, r),
                                        c.splice(h, 1)
                                    )
                                  : n ||
                                    (
                                        u.removeEventListener(d, v.proxyListener, r),
                                        c.splice(h, 1)
                                    );
                        }
                }
            return this;
        },
        trigger: function() {
            for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
            for (var i = e[0].split(' '), a = e[1], s = 0; s < i.length; s += 1)
                for (var n = i[s], r = 0; r < this.length; r += 1) {
                    var o = this[r],
                        l = void 0;
                    try {
                        l = new Z.CustomEvent(n, {
                            detail: a,
                            bubbles: !0,
                            cancelable: !0
                        });
                    } catch (e) {
                        (l = f.createEvent('Event')).initEvent(n, !0, !0), (l.detail = a);
                    }
                    (o.dom7EventData = e.filter(function(e, t) {
                        return 0 < t;
                    })), o.dispatchEvent(
                        l
                    ), (o.dom7EventData = []), delete o.dom7EventData;
                }
            return this;
        },
        transitionEnd: function(t) {
            var i,
                a = ['webkitTransitionEnd', 'transitionend'],
                s = this;
            function n(e) {
                if (e.target === this)
                    for (t.call(this, e), i = 0; i < a.length; i += 1) s.off(a[i], n);
            }
            if (t) for (i = 0; i < a.length; i += 1) s.on(a[i], n);
            return this;
        },
        outerWidth: function(e) {
            if (0 < this.length) {
                if (e) {
                    var t = this.styles();
                    return (
                        this[0].offsetWidth +
                        parseFloat(t.getPropertyValue('margin-right')) +
                        parseFloat(t.getPropertyValue('margin-left'))
                    );
                }
                return this[0].offsetWidth;
            }
            return null;
        },
        outerHeight: function(e) {
            if (0 < this.length) {
                if (e) {
                    var t = this.styles();
                    return (
                        this[0].offsetHeight +
                        parseFloat(t.getPropertyValue('margin-top')) +
                        parseFloat(t.getPropertyValue('margin-bottom'))
                    );
                }
                return this[0].offsetHeight;
            }
            return null;
        },
        offset: function() {
            if (0 < this.length) {
                var e = this[0],
                    t = e.getBoundingClientRect(),
                    i = f.body,
                    a = e.clientTop || i.clientTop || 0,
                    s = e.clientLeft || i.clientLeft || 0,
                    n = e === Z ? Z.scrollY : e.scrollTop,
                    r = e === Z ? Z.scrollX : e.scrollLeft;
                return { top: t.top + n - a, left: t.left + r - s };
            }
            return null;
        },
        css: function(e, t) {
            var i;
            if (1 === arguments.length) {
                if ('string' != typeof e) {
                    for (i = 0; i < this.length; i += 1)
                        for (var a in e) this[i].style[a] = e[a];
                    return this;
                }
                if (this[0]) return Z.getComputedStyle(this[0], null).getPropertyValue(e);
            }
            if (2 !== arguments.length || 'string' != typeof e) return this;
            for (i = 0; i < this.length; i += 1) this[i].style[e] = t;
            return this;
        },
        each: function(e) {
            if (!e) return this;
            for (var t = 0; t < this.length; t += 1)
                if (!1 === e.call(this[t], t, this[t])) return this;
            return this;
        },
        html: function(e) {
            if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;
            for (var t = 0; t < this.length; t += 1) this[t].innerHTML = e;
            return this;
        },
        text: function(e) {
            if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;
            for (var t = 0; t < this.length; t += 1) this[t].textContent = e;
            return this;
        },
        is: function(e) {
            var t,
                i,
                a = this[0];
            if (!a || void 0 === e) return !1;
            if ('string' == typeof e) {
                if (a.matches) return a.matches(e);
                if (a.webkitMatchesSelector) return a.webkitMatchesSelector(e);
                if (a.msMatchesSelector) return a.msMatchesSelector(e);
                for (t = C(e), i = 0; i < t.length; i += 1) if (t[i] === a) return !0;
                return !1;
            }
            if (e === f) return a === f;
            if (e === Z) return a === Z;
            if (e.nodeType || e instanceof l) {
                for (t = e.nodeType ? [e] : e, i = 0; i < t.length; i += 1)
                    if (t[i] === a) return !0;
                return !1;
            }
            return !1;
        },
        index: function() {
            var e,
                t = this[0];
            if (t) {
                for (e = 0; null !== (t = t.previousSibling); )
                    1 === t.nodeType && (e += 1);
                return e;
            }
        },
        eq: function(e) {
            if (void 0 === e) return this;
            var t,
                i = this.length;
            return new l(
                i - 1 < e ? [] : e < 0 ? ((t = i + e) < 0 ? [] : [this[t]]) : [this[e]]
            );
        },
        append: function() {
            for (var e, t = [], i = arguments.length; i--; ) t[i] = arguments[i];
            for (var a = 0; a < t.length; a += 1) {
                e = t[a];
                for (var s = 0; s < this.length; s += 1)
                    if ('string' == typeof e) {
                        var n = f.createElement('div');
                        for (n.innerHTML = e; n.firstChild; )
                            this[s].appendChild(n.firstChild);
                    } else if (e instanceof l)
                        for (var r = 0; r < e.length; r += 1) this[s].appendChild(e[r]);
                    else this[s].appendChild(e);
            }
            return this;
        },
        prepend: function(e) {
            var t, i;
            for (t = 0; t < this.length; t += 1)
                if ('string' == typeof e) {
                    var a = f.createElement('div');
                    for (a.innerHTML = e, i = a.childNodes.length - 1; 0 <= i; i -= 1)
                        this[t].insertBefore(a.childNodes[i], this[t].childNodes[0]);
                } else if (e instanceof l)
                    for (i = 0; i < e.length; i += 1)
                        this[t].insertBefore(e[i], this[t].childNodes[0]);
                else this[t].insertBefore(e, this[t].childNodes[0]);
            return this;
        },
        next: function(e) {
            return 0 < this.length
                ? e
                  ? this[0].nextElementSibling && C(this[0].nextElementSibling).is(e)
                    ? new l([this[0].nextElementSibling])
                    : new l([])
                  : this[0].nextElementSibling
                    ? new l([this[0].nextElementSibling])
                    : new l([])
                : new l([]);
        },
        nextAll: function(e) {
            var t = [],
                i = this[0];
            if (!i) return new l([]);
            for (; i.nextElementSibling; ) {
                var a = i.nextElementSibling;
                e ? C(a).is(e) && t.push(a) : t.push(a), (i = a);
            }
            return new l(t);
        },
        prev: function(e) {
            if (0 < this.length) {
                var t = this[0];
                return e
                    ? t.previousElementSibling && C(t.previousElementSibling).is(e)
                      ? new l([t.previousElementSibling])
                      : new l([])
                    : t.previousElementSibling
                      ? new l([t.previousElementSibling])
                      : new l([]);
            }
            return new l([]);
        },
        prevAll: function(e) {
            var t = [],
                i = this[0];
            if (!i) return new l([]);
            for (; i.previousElementSibling; ) {
                var a = i.previousElementSibling;
                e ? C(a).is(e) && t.push(a) : t.push(a), (i = a);
            }
            return new l(t);
        },
        parent: function(e) {
            for (var t = [], i = 0; i < this.length; i += 1)
                null !== this[i].parentNode &&
                    (e
                        ? C(this[i].parentNode).is(e) && t.push(this[i].parentNode)
                        : t.push(this[i].parentNode));
            return C(n(t));
        },
        parents: function(e) {
            for (var t = [], i = 0; i < this.length; i += 1)
                for (var a = this[i].parentNode; a; )
                    e ? C(a).is(e) && t.push(a) : t.push(a), (a = a.parentNode);
            return C(n(t));
        },
        closest: function(e) {
            var t = this;
            return void 0 === e ? new l([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
        },
        find: function(e) {
            for (var t = [], i = 0; i < this.length; i += 1)
                for (var a = this[i].querySelectorAll(e), s = 0; s < a.length; s += 1)
                    t.push(a[s]);
            return new l(t);
        },
        children: function(e) {
            for (var t = [], i = 0; i < this.length; i += 1)
                for (var a = this[i].childNodes, s = 0; s < a.length; s += 1)
                    e
                        ? 1 === a[s].nodeType && C(a[s]).is(e) && t.push(a[s])
                        : 1 === a[s].nodeType && t.push(a[s]);
            return new l(n(t));
        },
        remove: function() {
            for (var e = 0; e < this.length; e += 1)
                this[e].parentNode && this[e].parentNode.removeChild(this[e]);
            return this;
        },
        add: function() {
            for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
            var i, a;
            for (i = 0; i < e.length; i += 1) {
                var s = C(e[i]);
                for (a = 0; a < s.length; a += 1)
                    (this[this.length] = s[a]), (this.length += 1);
            }
            return this;
        },
        styles: function() {
            return this[0] ? Z.getComputedStyle(this[0], null) : {};
        }
    };
    Object.keys(t).forEach(function(e) {
        C.fn[e] = C.fn[e] || t[e];
    });
    function e(e) {
        void 0 === e && (e = {});
        var t = this;
        (t.params = e), (t.eventsListeners = {}), t.params &&
            t.params.on &&
            Object.keys(t.params.on).forEach(function(e) {
                t.on(e, t.params.on[e]);
            });
    }
    var i,
        a,
        s,
        r,
        ee = {
            deleteProps: function(e) {
                var t = e;
                Object.keys(t).forEach(function(e) {
                    try {
                        t[e] = null;
                    } catch (e) {}
                    try {
                        delete t[e];
                    } catch (e) {}
                });
            },
            nextTick: function(e, t) {
                return void 0 === t && (t = 0), setTimeout(e, t);
            },
            now: function() {
                return Date.now();
            },
            getTranslate: function(e, t) {
                var i, a, s;
                void 0 === t && (t = 'x');
                var n = Z.getComputedStyle(e, null);
                return Z.WebKitCSSMatrix
                    ? (
                          6 < (a = n.transform || n.webkitTransform).split(',').length &&
                              (a = a
                                  .split(', ')
                                  .map(function(e) {
                                      return e.replace(',', '.');
                                  })
                                  .join(', ')),
                          (s = new Z.WebKitCSSMatrix('none' === a ? '' : a))
                      )
                    : (i = (s =
                          n.MozTransform ||
                          n.OTransform ||
                          n.MsTransform ||
                          n.msTransform ||
                          n.transform ||
                          n
                              .getPropertyValue('transform')
                              .replace('translate(', 'matrix(1, 0, 0, 1,'))
                          .toString()
                          .split(',')), 'x' === t &&
                    (a = Z.WebKitCSSMatrix
                        ? s.m41
                        : 16 === i.length ? parseFloat(i[12]) : parseFloat(i[4])), 'y' ===
                    t &&
                    (a = Z.WebKitCSSMatrix
                        ? s.m42
                        : 16 === i.length ? parseFloat(i[13]) : parseFloat(i[5])), a || 0;
            },
            parseUrlQuery: function(e) {
                var t,
                    i,
                    a,
                    s,
                    n = {},
                    r = e || Z.location.href;
                if ('string' == typeof r && r.length)
                    for (
                        s = (i = (r = -1 < r.indexOf('?') ? r.replace(/\S*\?/, '') : '')
                            .split('&')
                            .filter(function(e) {
                                return '' !== e;
                            })).length, t = 0;
                        t < s;
                        t += 1
                    )
                        (a = i[t].replace(/#\S+/g, '').split('=')), (n[
                            decodeURIComponent(a[0])
                        ] =
                            void 0 === a[1] ? void 0 : decodeURIComponent(a[1]) || '');
                return n;
            },
            isObject: function(e) {
                return (
                    'object' == typeof e &&
                    null !== e &&
                    e.constructor &&
                    e.constructor === Object
                );
            },
            extend: function() {
                for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
                for (var i = Object(e[0]), a = 1; a < e.length; a += 1) {
                    var s = e[a];
                    if (null != s)
                        for (
                            var n = Object.keys(Object(s)), r = 0, o = n.length;
                            r < o;
                            r += 1
                        ) {
                            var l = n[r],
                                d = Object.getOwnPropertyDescriptor(s, l);
                            void 0 !== d &&
                                d.enumerable &&
                                (ee.isObject(i[l]) && ee.isObject(s[l])
                                    ? ee.extend(i[l], s[l])
                                    : !ee.isObject(i[l]) && ee.isObject(s[l])
                                      ? ((i[l] = {}), ee.extend(i[l], s[l]))
                                      : (i[l] = s[l]));
                        }
                }
                return i;
            }
        },
        te = (
            (s = f.createElement('div')),
            {
                touch:
                    (Z.Modernizr && !0 === Z.Modernizr.touch) ||
                    !!(
                        0 < Z.navigator.maxTouchPoints ||
                        'ontouchstart' in Z ||
                        (Z.DocumentTouch && f instanceof Z.DocumentTouch)
                    ),
                pointerEvents: !!(
                    Z.navigator.pointerEnabled ||
                    Z.PointerEvent ||
                    ('maxTouchPoints' in Z.navigator && 0 < Z.navigator.maxTouchPoints)
                ),
                prefixedPointerEvents: !!Z.navigator.msPointerEnabled,
                transition: (
                    (a = s.style),
                    'transition' in a || 'webkitTransition' in a || 'MozTransition' in a
                ),
                transforms3d:
                    (Z.Modernizr && !0 === Z.Modernizr.csstransforms3d) ||
                    (
                        (i = s.style),
                        'webkitPerspective' in i ||
                            'MozPerspective' in i ||
                            'OPerspective' in i ||
                            'MsPerspective' in i ||
                            'perspective' in i
                    ),
                flexbox: (function() {
                    for (
                        var e = s.style,
                            t = 'alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient'.split(
                                ' '
                            ),
                            i = 0;
                        i < t.length;
                        i += 1
                    )
                        if (t[i] in e) return !0;
                    return !1;
                })(),
                observer: 'MutationObserver' in Z || 'WebkitMutationObserver' in Z,
                passiveListener: (function() {
                    var e = !1;
                    try {
                        var t = Object.defineProperty({}, 'passive', {
                            get: function() {
                                e = !0;
                            }
                        });
                        Z.addEventListener('testPassiveListener', null, t);
                    } catch (e) {}
                    return e;
                })(),
                gestures: 'ongesturestart' in Z
            }
        ),
        o = {
            isIE:
                !!Z.navigator.userAgent.match(/Trident/g) ||
                !!Z.navigator.userAgent.match(/MSIE/g),
            isEdge: !!Z.navigator.userAgent.match(/Edge/g),
            isSafari: (
                (r = Z.navigator.userAgent.toLowerCase()),
                0 <= r.indexOf('safari') &&
                    r.indexOf('chrome') < 0 &&
                    r.indexOf('android') < 0
            ),
            isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
                Z.navigator.userAgent
            )
        },
        d = { components: { configurable: !0 } };
    (e.prototype.on = function(e, t, i) {
        var a = this;
        if ('function' != typeof t) return a;
        var s = i ? 'unshift' : 'push';
        return e.split(' ').forEach(function(e) {
            a.eventsListeners[e] ||
                (a.eventsListeners[e] = []), a.eventsListeners[e][s](t);
        }), a;
    }), (e.prototype.once = function(i, a, e) {
        var s = this;
        if ('function' != typeof a) return s;
        function n() {
            for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
            a.apply(s, e), s.off(i, n), n.f7proxy && delete n.f7proxy;
        }
        return (n.f7proxy = a), s.on(i, n, e);
    }), (e.prototype.off = function(e, a) {
        var s = this;
        return s.eventsListeners &&
            e.split(' ').forEach(function(i) {
                void 0 === a
                    ? (s.eventsListeners[i] = [])
                    : s.eventsListeners[i] &&
                      s.eventsListeners[i].length &&
                      s.eventsListeners[i].forEach(function(e, t) {
                          (e === a || (e.f7proxy && e.f7proxy === a)) &&
                              s.eventsListeners[i].splice(t, 1);
                      });
            }), s;
    }), (e.prototype.emit = function() {
        for (var e = [], t = arguments.length; t--; ) e[t] = arguments[t];
        var i,
            a,
            s,
            n = this;
        return n.eventsListeners &&
            (
                (s =
                    'string' == typeof e[0] || Array.isArray(e[0])
                        ? ((i = e[0]), (a = e.slice(1, e.length)), n)
                        : ((i = e[0].events), (a = e[0].data), e[0].context || n)),
                (Array.isArray(i) ? i : i.split(' ')).forEach(function(e) {
                    if (n.eventsListeners && n.eventsListeners[e]) {
                        var t = [];
                        n.eventsListeners[e].forEach(function(e) {
                            t.push(e);
                        }), t.forEach(function(e) {
                            e.apply(s, a);
                        });
                    }
                })
            ), n;
    }), (e.prototype.useModulesParams = function(i) {
        var a = this;
        a.modules &&
            Object.keys(a.modules).forEach(function(e) {
                var t = a.modules[e];
                t.params && ee.extend(i, t.params);
            });
    }), (e.prototype.useModules = function(a) {
        void 0 === a && (a = {});
        var s = this;
        s.modules &&
            Object.keys(s.modules).forEach(function(e) {
                var i = s.modules[e],
                    t = a[e] || {};
                i.instance &&
                    Object.keys(i.instance).forEach(function(e) {
                        var t = i.instance[e];
                        s[e] = 'function' == typeof t ? t.bind(s) : t;
                    }), i.on &&
                    s.on &&
                    Object.keys(i.on).forEach(function(e) {
                        s.on(e, i.on[e]);
                    }), i.create && i.create.bind(s)(t);
            });
    }), (d.components.set = function(e) {
        this.use && this.use(e);
    }), (e.installModule = function(t) {
        for (var e = [], i = arguments.length - 1; 0 < i--; ) e[i] = arguments[i + 1];
        var a = this;
        a.prototype.modules || (a.prototype.modules = {});
        var s = t.name || Object.keys(a.prototype.modules).length + '_' + ee.now();
        return (a.prototype.modules[s] = t).proto &&
            Object.keys(t.proto).forEach(function(e) {
                a.prototype[e] = t.proto[e];
            }), t.static &&
            Object.keys(t.static).forEach(function(e) {
                a[e] = t.static[e];
            }), t.install && t.install.apply(a, e), a;
    }), (e.use = function(e) {
        for (var t = [], i = arguments.length - 1; 0 < i--; ) t[i] = arguments[i + 1];
        var a = this;
        return Array.isArray(e)
            ? (
                  e.forEach(function(e) {
                      return a.installModule(e);
                  }),
                  a
              )
            : a.installModule.apply(a, [e].concat(t));
    }), Object.defineProperties(e, d);
    var p = {
        updateSize: function() {
            var e,
                t,
                i = this,
                a = i.$el;
            (e = void 0 !== i.params.width ? i.params.width : a[0].clientWidth), (t =
                void 0 !== i.params.height ? i.params.height : a[0].clientHeight), (0 ===
                e &&
                i.isHorizontal()) ||
                (0 === t && i.isVertical()) ||
                (
                    (e =
                        e -
                        parseInt(a.css('padding-left'), 10) -
                        parseInt(a.css('padding-right'), 10)),
                    (t =
                        t -
                        parseInt(a.css('padding-top'), 10) -
                        parseInt(a.css('padding-bottom'), 10)),
                    ee.extend(i, { width: e, height: t, size: i.isHorizontal() ? e : t })
                );
        },
        updateSlides: function() {
            var e = this,
                t = e.params,
                i = e.$wrapperEl,
                a = e.size,
                s = e.rtlTranslate,
                n = e.wrongRTL,
                r = e.virtual && t.virtual.enabled,
                o = r ? e.virtual.slides.length : e.slides.length,
                l = i.children('.' + e.params.slideClass),
                d = r ? e.virtual.slides.length : l.length,
                p = [],
                u = [],
                c = [],
                h = t.slidesOffsetBefore;
            'function' == typeof h && (h = t.slidesOffsetBefore.call(e));
            var v = t.slidesOffsetAfter;
            'function' == typeof v && (v = t.slidesOffsetAfter.call(e));
            var f = e.snapGrid.length,
                m = e.snapGrid.length,
                g = t.spaceBetween,
                w = -h,
                y = 0,
                b = 0;
            if (void 0 !== a) {
                var C, x;
                'string' == typeof g &&
                    0 <= g.indexOf('%') &&
                    (g =
                        parseFloat(g.replace('%', '')) / 100 * a), (e.virtualSize = -g), s
                    ? l.css({ marginLeft: '', marginTop: '' })
                    : l.css({ marginRight: '', marginBottom: '' }), 1 <
                    t.slidesPerColumn &&
                    (
                        (C =
                            Math.floor(d / t.slidesPerColumn) ===
                            d / e.params.slidesPerColumn
                                ? d
                                : Math.ceil(d / t.slidesPerColumn) * t.slidesPerColumn),
                        'auto' !== t.slidesPerView &&
                            'row' === t.slidesPerColumnFill &&
                            (C = Math.max(C, t.slidesPerView * t.slidesPerColumn))
                    );
                for (
                    var T,
                        S = t.slidesPerColumn,
                        E = C / S,
                        M = Math.floor(d / t.slidesPerColumn),
                        P = 0;
                    P < d;
                    P += 1
                ) {
                    x = 0;
                    var k = l.eq(P);
                    if (1 < t.slidesPerColumn) {
                        var L = void 0,
                            z = void 0,
                            I = void 0;
                        'column' === t.slidesPerColumnFill
                            ? (
                                  (I = P - (z = Math.floor(P / S)) * S),
                                  (M < z || (z === M && I === S - 1)) &&
                                      S <= (I += 1) &&
                                      ((I = 0), (z += 1)),
                                  (L = z + I * C / S),
                                  k.css({
                                      '-webkit-box-ordinal-group': L,
                                      '-moz-box-ordinal-group': L,
                                      '-ms-flex-order': L,
                                      '-webkit-order': L,
                                      order: L
                                  })
                              )
                            : (z = P - (I = Math.floor(P / E)) * E), k
                            .css(
                                'margin-' + (e.isHorizontal() ? 'top' : 'left'),
                                0 !== I && t.spaceBetween && t.spaceBetween + 'px'
                            )
                            .attr('data-swiper-column', z)
                            .attr('data-swiper-row', I);
                    }
                    if ('none' !== k.css('display')) {
                        if ('auto' === t.slidesPerView) {
                            var O = Z.getComputedStyle(k[0], null),
                                D = k[0].style.transform,
                                A = k[0].style.webkitTransform;
                            if (
                                (
                                    D && (k[0].style.transform = 'none'),
                                    A && (k[0].style.webkitTransform = 'none'),
                                    t.roundLengths
                                )
                            )
                                x = e.isHorizontal()
                                    ? k.outerWidth(!0)
                                    : k.outerHeight(!0);
                            else if (e.isHorizontal()) {
                                var B = parseFloat(O.getPropertyValue('width')),
                                    V = parseFloat(O.getPropertyValue('padding-left')),
                                    $ = parseFloat(O.getPropertyValue('padding-right')),
                                    N = parseFloat(O.getPropertyValue('margin-left')),
                                    G = parseFloat(O.getPropertyValue('margin-right')),
                                    F = O.getPropertyValue('box-sizing');
                                x =
                                    F && 'border-box' === F
                                        ? B + N + G
                                        : B + V + $ + N + G;
                            } else {
                                var H = parseFloat(O.getPropertyValue('height')),
                                    j = parseFloat(O.getPropertyValue('padding-top')),
                                    q = parseFloat(O.getPropertyValue('padding-bottom')),
                                    R = parseFloat(O.getPropertyValue('margin-top')),
                                    W = parseFloat(O.getPropertyValue('margin-bottom')),
                                    X = O.getPropertyValue('box-sizing');
                                x =
                                    X && 'border-box' === X
                                        ? H + R + W
                                        : H + j + q + R + W;
                            }
                            D && (k[0].style.transform = D), A &&
                                (k[0].style.webkitTransform = A), t.roundLengths &&
                                (x = Math.floor(x));
                        } else
                            (x =
                                (a - (t.slidesPerView - 1) * g) /
                                t.slidesPerView), t.roundLengths &&
                                (x = Math.floor(x)), l[P] &&
                                (e.isHorizontal()
                                    ? (l[P].style.width = x + 'px')
                                    : (l[P].style.height = x + 'px'));
                        l[P] && (l[P].swiperSlideSize = x), c.push(x), t.centeredSlides
                            ? (
                                  (w = w + x / 2 + y / 2 + g),
                                  0 === y && 0 !== P && (w = w - a / 2 - g),
                                  0 === P && (w = w - a / 2 - g),
                                  Math.abs(w) < 0.001 && (w = 0),
                                  t.roundLengths && (w = Math.floor(w)),
                                  b % t.slidesPerGroup == 0 && p.push(w),
                                  u.push(w)
                              )
                            : (
                                  t.roundLengths && (w = Math.floor(w)),
                                  b % t.slidesPerGroup == 0 && p.push(w),
                                  u.push(w),
                                  (w = w + x + g)
                              ), (e.virtualSize += x + g), (y = x), (b += 1);
                    }
                }
                if (
                    (
                        (e.virtualSize = Math.max(e.virtualSize, a) + v),
                        s &&
                            n &&
                            ('slide' === t.effect || 'coverflow' === t.effect) &&
                            i.css({ width: e.virtualSize + t.spaceBetween + 'px' }),
                        (te.flexbox && !t.setWrapperSize) ||
                            (e.isHorizontal()
                                ? i.css({ width: e.virtualSize + t.spaceBetween + 'px' })
                                : i.css({
                                      height: e.virtualSize + t.spaceBetween + 'px'
                                  })),
                        1 < t.slidesPerColumn &&
                            (
                                (e.virtualSize = (x + t.spaceBetween) * C),
                                (e.virtualSize =
                                    Math.ceil(e.virtualSize / t.slidesPerColumn) -
                                    t.spaceBetween),
                                e.isHorizontal()
                                    ? i.css({
                                          width: e.virtualSize + t.spaceBetween + 'px'
                                      })
                                    : i.css({
                                          height: e.virtualSize + t.spaceBetween + 'px'
                                      }),
                                t.centeredSlides
                            )
                    )
                ) {
                    T = [];
                    for (var Y = 0; Y < p.length; Y += 1) {
                        var U = p[Y];
                        t.roundLengths && (U = Math.floor(U)), p[Y] <
                            e.virtualSize + p[0] && T.push(U);
                    }
                    p = T;
                }
                if (!t.centeredSlides) {
                    T = [];
                    for (var _ = 0; _ < p.length; _ += 1) {
                        var K = p[_];
                        t.roundLengths && (K = Math.floor(K)), p[_] <=
                            e.virtualSize - a && T.push(K);
                    }
                    (p = T), 1 <
                        Math.floor(e.virtualSize - a) - Math.floor(p[p.length - 1]) &&
                        p.push(e.virtualSize - a);
                }
                if (
                    (
                        0 === p.length && (p = [0]),
                        0 !== t.spaceBetween &&
                            (e.isHorizontal()
                                ? s
                                  ? l.css({ marginLeft: g + 'px' })
                                  : l.css({ marginRight: g + 'px' })
                                : l.css({ marginBottom: g + 'px' })),
                        t.centerInsufficientSlides
                    )
                ) {
                    var Q = 0;
                    if (
                        (
                            c.forEach(function(e) {
                                Q += e + (t.spaceBetween ? t.spaceBetween : 0);
                            }),
                            (Q -= t.spaceBetween) < a
                        )
                    ) {
                        var J = (a - Q) / 2;
                        p.forEach(function(e, t) {
                            p[t] = e - J;
                        }), u.forEach(function(e, t) {
                            u[t] = e + J;
                        });
                    }
                }
                ee.extend(e, {
                    slides: l,
                    snapGrid: p,
                    slidesGrid: u,
                    slidesSizesGrid: c
                }), d !== o && e.emit('slidesLengthChange'), p.length !== f &&
                    (
                        e.params.watchOverflow && e.checkOverflow(),
                        e.emit('snapGridLengthChange')
                    ), u.length !== m &&
                    e.emit('slidesGridLengthChange'), (t.watchSlidesProgress ||
                    t.watchSlidesVisibility) &&
                    e.updateSlidesOffset();
            }
        },
        updateAutoHeight: function(e) {
            var t,
                i = this,
                a = [],
                s = 0;
            if (
                (
                    'number' == typeof e
                        ? i.setTransition(e)
                        : !0 === e && i.setTransition(i.params.speed),
                    'auto' !== i.params.slidesPerView && 1 < i.params.slidesPerView
                )
            )
                for (t = 0; t < Math.ceil(i.params.slidesPerView); t += 1) {
                    var n = i.activeIndex + t;
                    if (n > i.slides.length) break;
                    a.push(i.slides.eq(n)[0]);
                }
            else a.push(i.slides.eq(i.activeIndex)[0]);
            for (t = 0; t < a.length; t += 1)
                if (void 0 !== a[t]) {
                    var r = a[t].offsetHeight;
                    s = s < r ? r : s;
                }
            s && i.$wrapperEl.css('height', s + 'px');
        },
        updateSlidesOffset: function() {
            for (var e = this.slides, t = 0; t < e.length; t += 1)
                e[t].swiperSlideOffset = this.isHorizontal()
                    ? e[t].offsetLeft
                    : e[t].offsetTop;
        },
        updateSlidesProgress: function(e) {
            void 0 === e && (e = (this && this.translate) || 0);
            var t = this,
                i = t.params,
                a = t.slides,
                s = t.rtlTranslate;
            if (0 !== a.length) {
                void 0 === a[0].swiperSlideOffset && t.updateSlidesOffset();
                var n = -e;
                s && (n = e), a.removeClass(
                    i.slideVisibleClass
                ), (t.visibleSlidesIndexes = []), (t.visibleSlides = []);
                for (var r = 0; r < a.length; r += 1) {
                    var o = a[r],
                        l =
                            (n +
                                (i.centeredSlides ? t.minTranslate() : 0) -
                                o.swiperSlideOffset) /
                            (o.swiperSlideSize + i.spaceBetween);
                    if (i.watchSlidesVisibility) {
                        var d = -(n - o.swiperSlideOffset),
                            p = d + t.slidesSizesGrid[r];
                        ((0 <= d && d < t.size) ||
                            (0 < p && p <= t.size) ||
                            (d <= 0 && p >= t.size)) &&
                            (
                                t.visibleSlides.push(o),
                                t.visibleSlidesIndexes.push(r),
                                a.eq(r).addClass(i.slideVisibleClass)
                            );
                    }
                    o.progress = s ? -l : l;
                }
                t.visibleSlides = C(t.visibleSlides);
            }
        },
        updateProgress: function(e) {
            void 0 === e && (e = (this && this.translate) || 0);
            var t = this,
                i = t.params,
                a = t.maxTranslate() - t.minTranslate(),
                s = t.progress,
                n = t.isBeginning,
                r = t.isEnd,
                o = n,
                l = r;
            (r =
                0 == a
                    ? (n = !(s = 0))
                    : (
                          (n = (s = (e - t.minTranslate()) / a) <= 0),
                          1 <= s
                      )), ee.extend(t, {
                progress: s,
                isBeginning: n,
                isEnd: r
            }), (i.watchSlidesProgress || i.watchSlidesVisibility) &&
                t.updateSlidesProgress(e), n &&
                !o &&
                t.emit('reachBeginning toEdge'), r &&
                !l &&
                t.emit('reachEnd toEdge'), ((o && !n) || (l && !r)) &&
                t.emit('fromEdge'), t.emit('progress', s);
        },
        updateSlidesClasses: function() {
            var e,
                t = this,
                i = t.slides,
                a = t.params,
                s = t.$wrapperEl,
                n = t.activeIndex,
                r = t.realIndex,
                o = t.virtual && a.virtual.enabled;
            i.removeClass(
                a.slideActiveClass +
                    ' ' +
                    a.slideNextClass +
                    ' ' +
                    a.slidePrevClass +
                    ' ' +
                    a.slideDuplicateActiveClass +
                    ' ' +
                    a.slideDuplicateNextClass +
                    ' ' +
                    a.slideDuplicatePrevClass
            ), (e = o
                ? t.$wrapperEl.find(
                      '.' + a.slideClass + '[data-swiper-slide-index="' + n + '"]'
                  )
                : i.eq(n)).addClass(a.slideActiveClass), a.loop &&
                (e.hasClass(a.slideDuplicateClass)
                    ? s
                          .children(
                              '.' +
                                  a.slideClass +
                                  ':not(.' +
                                  a.slideDuplicateClass +
                                  ')[data-swiper-slide-index="' +
                                  r +
                                  '"]'
                          )
                          .addClass(a.slideDuplicateActiveClass)
                    : s
                          .children(
                              '.' +
                                  a.slideClass +
                                  '.' +
                                  a.slideDuplicateClass +
                                  '[data-swiper-slide-index="' +
                                  r +
                                  '"]'
                          )
                          .addClass(a.slideDuplicateActiveClass));
            var l = e.nextAll('.' + a.slideClass).eq(0).addClass(a.slideNextClass);
            a.loop && 0 === l.length && (l = i.eq(0)).addClass(a.slideNextClass);
            var d = e.prevAll('.' + a.slideClass).eq(0).addClass(a.slidePrevClass);
            a.loop &&
                0 === d.length &&
                (d = i.eq(-1)).addClass(a.slidePrevClass), a.loop &&
                (
                    l.hasClass(a.slideDuplicateClass)
                        ? s
                              .children(
                                  '.' +
                                      a.slideClass +
                                      ':not(.' +
                                      a.slideDuplicateClass +
                                      ')[data-swiper-slide-index="' +
                                      l.attr('data-swiper-slide-index') +
                                      '"]'
                              )
                              .addClass(a.slideDuplicateNextClass)
                        : s
                              .children(
                                  '.' +
                                      a.slideClass +
                                      '.' +
                                      a.slideDuplicateClass +
                                      '[data-swiper-slide-index="' +
                                      l.attr('data-swiper-slide-index') +
                                      '"]'
                              )
                              .addClass(a.slideDuplicateNextClass),
                    d.hasClass(a.slideDuplicateClass)
                        ? s
                              .children(
                                  '.' +
                                      a.slideClass +
                                      ':not(.' +
                                      a.slideDuplicateClass +
                                      ')[data-swiper-slide-index="' +
                                      d.attr('data-swiper-slide-index') +
                                      '"]'
                              )
                              .addClass(a.slideDuplicatePrevClass)
                        : s
                              .children(
                                  '.' +
                                      a.slideClass +
                                      '.' +
                                      a.slideDuplicateClass +
                                      '[data-swiper-slide-index="' +
                                      d.attr('data-swiper-slide-index') +
                                      '"]'
                              )
                              .addClass(a.slideDuplicatePrevClass)
                );
        },
        updateActiveIndex: function(e) {
            var t,
                i = this,
                a = i.rtlTranslate ? i.translate : -i.translate,
                s = i.slidesGrid,
                n = i.snapGrid,
                r = i.params,
                o = i.activeIndex,
                l = i.realIndex,
                d = i.snapIndex,
                p = e;
            if (void 0 === p) {
                for (var u = 0; u < s.length; u += 1)
                    void 0 !== s[u + 1]
                        ? a >= s[u] && a < s[u + 1] - (s[u + 1] - s[u]) / 2
                          ? (p = u)
                          : a >= s[u] && a < s[u + 1] && (p = u + 1)
                        : a >= s[u] && (p = u);
                r.normalizeSlideIndex && (p < 0 || void 0 === p) && (p = 0);
            }
            if (
                (
                    (t =
                        0 <= n.indexOf(a)
                            ? n.indexOf(a)
                            : Math.floor(p / r.slidesPerGroup)) >= n.length &&
                        (t = n.length - 1),
                    p !== o
                )
            ) {
                var c = parseInt(i.slides.eq(p).attr('data-swiper-slide-index') || p, 10);
                ee.extend(i, {
                    snapIndex: t,
                    realIndex: c,
                    previousIndex: o,
                    activeIndex: p
                }), i.emit('activeIndexChange'), i.emit('snapIndexChange'), l !== c &&
                    i.emit('realIndexChange'), (i.initialized || i.runCallbacksOnInit) &&
                    i.emit('slideChange');
            } else t !== d && ((i.snapIndex = t), i.emit('snapIndexChange'));
        },
        updateClickedSlide: function(e) {
            var t = this,
                i = t.params,
                a = C(e.target).closest('.' + i.slideClass)[0],
                s = !1;
            if (a)
                for (var n = 0; n < t.slides.length; n += 1)
                    t.slides[n] === a && (s = !0);
            if (!a || !s)
                return (t.clickedSlide = void 0), void (t.clickedIndex = void 0);
            (t.clickedSlide = a), t.virtual && t.params.virtual.enabled
                ? (t.clickedIndex = parseInt(C(a).attr('data-swiper-slide-index'), 10))
                : (t.clickedIndex = C(a).index()), i.slideToClickedSlide &&
                void 0 !== t.clickedIndex &&
                t.clickedIndex !== t.activeIndex &&
                t.slideToClickedSlide();
        }
    };
    var u = {
        getTranslate: function(e) {
            void 0 === e && (e = this.isHorizontal() ? 'x' : 'y');
            var t = this.params,
                i = this.rtlTranslate,
                a = this.translate,
                s = this.$wrapperEl;
            if (t.virtualTranslate) return i ? -a : a;
            var n = ee.getTranslate(s[0], e);
            return i && (n = -n), n || 0;
        },
        setTranslate: function(e, t) {
            var i = this,
                a = i.rtlTranslate,
                s = i.params,
                n = i.$wrapperEl,
                r = i.progress,
                o = 0,
                l = 0;
            i.isHorizontal() ? (o = a ? -e : e) : (l = e), s.roundLengths &&
                ((o = Math.floor(o)), (l = Math.floor(l))), s.virtualTranslate ||
                (te.transforms3d
                    ? n.transform('translate3d(' + o + 'px, ' + l + 'px, 0px)')
                    : n.transform(
                          'translate(' + o + 'px, ' + l + 'px)'
                      )), (i.previousTranslate =
                i.translate), (i.translate = i.isHorizontal() ? o : l);
            var d = i.maxTranslate() - i.minTranslate();
            (0 == d ? 0 : (e - i.minTranslate()) / d) !== r &&
                i.updateProgress(e), i.emit('setTranslate', i.translate, t);
        },
        minTranslate: function() {
            return -this.snapGrid[0];
        },
        maxTranslate: function() {
            return -this.snapGrid[this.snapGrid.length - 1];
        }
    };
    var c = {
        setTransition: function(e, t) {
            this.$wrapperEl.transition(e), this.emit('setTransition', e, t);
        },
        transitionStart: function(e, t) {
            void 0 === e && (e = !0);
            var i = this,
                a = i.activeIndex,
                s = i.params,
                n = i.previousIndex;
            s.autoHeight && i.updateAutoHeight();
            var r = t;
            if (
                (
                    (r = r || (n < a ? 'next' : a < n ? 'prev' : 'reset')),
                    i.emit('transitionStart'),
                    e && a !== n
                )
            ) {
                if ('reset' === r) return void i.emit('slideResetTransitionStart');
                i.emit('slideChangeTransitionStart'), 'next' === r
                    ? i.emit('slideNextTransitionStart')
                    : i.emit('slidePrevTransitionStart');
            }
        },
        transitionEnd: function(e, t) {
            void 0 === e && (e = !0);
            var i = this,
                a = i.activeIndex,
                s = i.previousIndex;
            (i.animating = !1), i.setTransition(0);
            var n = t;
            if (
                (
                    (n = n || (s < a ? 'next' : a < s ? 'prev' : 'reset')),
                    i.emit('transitionEnd'),
                    e && a !== s
                )
            ) {
                if ('reset' === n) return void i.emit('slideResetTransitionEnd');
                i.emit('slideChangeTransitionEnd'), 'next' === n
                    ? i.emit('slideNextTransitionEnd')
                    : i.emit('slidePrevTransitionEnd');
            }
        }
    };
    var h = {
        slideTo: function(e, t, i, a) {
            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 ===
                i && (i = !0);
            var s = this,
                n = e;
            n < 0 && (n = 0);
            var r = s.params,
                o = s.snapGrid,
                l = s.slidesGrid,
                d = s.previousIndex,
                p = s.activeIndex,
                u = s.rtlTranslate;
            if (s.animating && r.preventInteractionOnTransition) return !1;
            var c = Math.floor(n / r.slidesPerGroup);
            c >= o.length && (c = o.length - 1), (p || r.initialSlide || 0) ===
                (d || 0) &&
                i &&
                s.emit('beforeSlideChangeStart');
            var h,
                v = -o[c];
            if ((s.updateProgress(v), r.normalizeSlideIndex))
                for (var f = 0; f < l.length; f += 1)
                    -Math.floor(100 * v) >= Math.floor(100 * l[f]) && (n = f);
            if (s.initialized && n !== p) {
                if (!s.allowSlideNext && v < s.translate && v < s.minTranslate())
                    return !1;
                if (
                    !s.allowSlidePrev &&
                    v > s.translate &&
                    v > s.maxTranslate() &&
                    (p || 0) !== n
                )
                    return !1;
            }
            return (h = p < n ? 'next' : n < p ? 'prev' : 'reset'), (u &&
                -v === s.translate) ||
            (!u && v === s.translate)
                ? (
                      s.updateActiveIndex(n),
                      r.autoHeight && s.updateAutoHeight(),
                      s.updateSlidesClasses(),
                      'slide' !== r.effect && s.setTranslate(v),
                      'reset' !== h && (s.transitionStart(i, h), s.transitionEnd(i, h)),
                      !1
                  )
                : (
                      0 !== t && te.transition
                          ? (
                                s.setTransition(t),
                                s.setTranslate(v),
                                s.updateActiveIndex(n),
                                s.updateSlidesClasses(),
                                s.emit('beforeTransitionStart', t, a),
                                s.transitionStart(i, h),
                                s.animating ||
                                    (
                                        (s.animating = !0),
                                        s.onSlideToWrapperTransitionEnd ||
                                            (s.onSlideToWrapperTransitionEnd = function(
                                                e
                                            ) {
                                                s &&
                                                    !s.destroyed &&
                                                    e.target === this &&
                                                    (
                                                        s.$wrapperEl[0].removeEventListener(
                                                            'transitionend',
                                                            s.onSlideToWrapperTransitionEnd
                                                        ),
                                                        s.$wrapperEl[0].removeEventListener(
                                                            'webkitTransitionEnd',
                                                            s.onSlideToWrapperTransitionEnd
                                                        ),
                                                        (s.onSlideToWrapperTransitionEnd = null),
                                                        delete s.onSlideToWrapperTransitionEnd,
                                                        s.transitionEnd(i, h)
                                                    );
                                            }),
                                        s.$wrapperEl[0].addEventListener(
                                            'transitionend',
                                            s.onSlideToWrapperTransitionEnd
                                        ),
                                        s.$wrapperEl[0].addEventListener(
                                            'webkitTransitionEnd',
                                            s.onSlideToWrapperTransitionEnd
                                        )
                                    )
                            )
                          : (
                                s.setTransition(0),
                                s.setTranslate(v),
                                s.updateActiveIndex(n),
                                s.updateSlidesClasses(),
                                s.emit('beforeTransitionStart', t, a),
                                s.transitionStart(i, h),
                                s.transitionEnd(i, h)
                            ),
                      !0
                  );
        },
        slideToLoop: function(e, t, i, a) {
            void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 ===
                i && (i = !0);
            var s = e;
            return this.params.loop && (s += this.loopedSlides), this.slideTo(s, t, i, a);
        },
        slideNext: function(e, t, i) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var a = this,
                s = a.params,
                n = a.animating;
            return s.loop
                ? !n &&
                  (
                      a.loopFix(),
                      (a._clientLeft = a.$wrapperEl[0].clientLeft),
                      a.slideTo(a.activeIndex + s.slidesPerGroup, e, t, i)
                  )
                : a.slideTo(a.activeIndex + s.slidesPerGroup, e, t, i);
        },
        slidePrev: function(e, t, i) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var a = this,
                s = a.params,
                n = a.animating,
                r = a.snapGrid,
                o = a.slidesGrid,
                l = a.rtlTranslate;
            if (s.loop) {
                if (n) return !1;
                a.loopFix(), (a._clientLeft = a.$wrapperEl[0].clientLeft);
            }
            function d(e) {
                return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
            }
            var p,
                u = d(l ? a.translate : -a.translate),
                c = r.map(function(e) {
                    return d(e);
                }),
                h = (
                    o.map(function(e) {
                        return d(e);
                    }),
                    r[c.indexOf(u)],
                    r[c.indexOf(u) - 1]
                );
            return void 0 !== h &&
                (p = o.indexOf(h)) < 0 &&
                (p = a.activeIndex - 1), a.slideTo(p, e, t, i);
        },
        slideReset: function(e, t, i) {
            return void 0 === e && (e = this.params.speed), void 0 === t &&
                (t = !0), this.slideTo(this.activeIndex, e, t, i);
        },
        slideToClosest: function(e, t, i) {
            void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
            var a = this,
                s = a.activeIndex,
                n = Math.floor(s / a.params.slidesPerGroup);
            if (n < a.snapGrid.length - 1) {
                var r = a.rtlTranslate ? a.translate : -a.translate,
                    o = a.snapGrid[n];
                (a.snapGrid[n + 1] - o) / 2 < r - o && (s = a.params.slidesPerGroup);
            }
            return a.slideTo(s, e, t, i);
        },
        slideToClickedSlide: function() {
            var e,
                t = this,
                i = t.params,
                a = t.$wrapperEl,
                s =
                    'auto' === i.slidesPerView
                        ? t.slidesPerViewDynamic()
                        : i.slidesPerView,
                n = t.clickedIndex;
            if (i.loop) {
                if (t.animating) return;
                (e = parseInt(
                    C(t.clickedSlide).attr('data-swiper-slide-index'),
                    10
                )), i.centeredSlides
                    ? n < t.loopedSlides - s / 2 ||
                      n > t.slides.length - t.loopedSlides + s / 2
                      ? (
                            t.loopFix(),
                            (n = a
                                .children(
                                    '.' +
                                        i.slideClass +
                                        '[data-swiper-slide-index="' +
                                        e +
                                        '"]:not(.' +
                                        i.slideDuplicateClass +
                                        ')'
                                )
                                .eq(0)
                                .index()),
                            ee.nextTick(function() {
                                t.slideTo(n);
                            })
                        )
                      : t.slideTo(n)
                    : n > t.slides.length - s
                      ? (
                            t.loopFix(),
                            (n = a
                                .children(
                                    '.' +
                                        i.slideClass +
                                        '[data-swiper-slide-index="' +
                                        e +
                                        '"]:not(.' +
                                        i.slideDuplicateClass +
                                        ')'
                                )
                                .eq(0)
                                .index()),
                            ee.nextTick(function() {
                                t.slideTo(n);
                            })
                        )
                      : t.slideTo(n);
            } else t.slideTo(n);
        }
    };
    var v = {
        loopCreate: function() {
            var a = this,
                e = a.params,
                t = a.$wrapperEl;
            t.children('.' + e.slideClass + '.' + e.slideDuplicateClass).remove();
            var s = t.children('.' + e.slideClass);
            if (e.loopFillGroupWithBlank) {
                var i = e.slidesPerGroup - s.length % e.slidesPerGroup;
                if (i !== e.slidesPerGroup) {
                    for (var n = 0; n < i; n += 1) {
                        var r = C(f.createElement('div')).addClass(
                            e.slideClass + ' ' + e.slideBlankClass
                        );
                        t.append(r);
                    }
                    s = t.children('.' + e.slideClass);
                }
            }
            'auto' !== e.slidesPerView ||
                e.loopedSlides ||
                (e.loopedSlides = s.length), (a.loopedSlides = parseInt(
                e.loopedSlides || e.slidesPerView,
                10
            )), (a.loopedSlides += e.loopAdditionalSlides), a.loopedSlides > s.length &&
                (a.loopedSlides = s.length);
            var o = [],
                l = [];
            s.each(function(e, t) {
                var i = C(t);
                e < a.loopedSlides &&
                    l.push(
                        t
                    ), e < s.length && e >= s.length - a.loopedSlides && o.push(t), i.attr('data-swiper-slide-index', e);
            });
            for (var d = 0; d < l.length; d += 1)
                t.append(C(l[d].cloneNode(!0)).addClass(e.slideDuplicateClass));
            for (var p = o.length - 1; 0 <= p; p -= 1)
                t.prepend(C(o[p].cloneNode(!0)).addClass(e.slideDuplicateClass));
        },
        loopFix: function() {
            var e,
                t = this,
                i = t.params,
                a = t.activeIndex,
                s = t.slides,
                n = t.loopedSlides,
                r = t.allowSlidePrev,
                o = t.allowSlideNext,
                l = t.snapGrid,
                d = t.rtlTranslate;
            (t.allowSlidePrev = !0), (t.allowSlideNext = !0);
            var p = -l[a] - t.getTranslate();
            if (a < n)
                (e = s.length - 3 * n + a), (e += n), t.slideTo(e, 0, !1, !0) &&
                    0 != p &&
                    t.setTranslate((d ? -t.translate : t.translate) - p);
            else if (('auto' === i.slidesPerView && 2 * n <= a) || a >= s.length - n) {
                (e = -s.length + a + n), (e += n), t.slideTo(e, 0, !1, !0) &&
                    0 != p &&
                    t.setTranslate((d ? -t.translate : t.translate) - p);
            }
            (t.allowSlidePrev = r), (t.allowSlideNext = o);
        },
        loopDestroy: function() {
            var e = this.$wrapperEl,
                t = this.params,
                i = this.slides;
            e
                .children(
                    '.' +
                        t.slideClass +
                        '.' +
                        t.slideDuplicateClass +
                        ',.' +
                        t.slideClass +
                        '.' +
                        t.slideBlankClass
                )
                .remove(), i.removeAttr('data-swiper-slide-index');
        }
    };
    var m = {
        setGrabCursor: function(e) {
            if (
                !(
                    te.touch ||
                    !this.params.simulateTouch ||
                    (this.params.watchOverflow && this.isLocked)
                )
            ) {
                var t = this.el;
                (t.style.cursor = 'move'), (t.style.cursor = e
                    ? '-webkit-grabbing'
                    : '-webkit-grab'), (t.style.cursor = e
                    ? '-moz-grabbin'
                    : '-moz-grab'), (t.style.cursor = e ? 'grabbing' : 'grab');
            }
        },
        unsetGrabCursor: function() {
            te.touch ||
                (this.params.watchOverflow && this.isLocked) ||
                (this.el.style.cursor = '');
        }
    };
    var g = {
            appendSlide: function(e) {
                var t = this,
                    i = t.$wrapperEl,
                    a = t.params;
                if ((a.loop && t.loopDestroy(), 'object' == typeof e && 'length' in e))
                    for (var s = 0; s < e.length; s += 1) e[s] && i.append(e[s]);
                else i.append(e);
                a.loop && t.loopCreate(), (a.observer && te.observer) || t.update();
            },
            prependSlide: function(e) {
                var t = this,
                    i = t.params,
                    a = t.$wrapperEl,
                    s = t.activeIndex;
                i.loop && t.loopDestroy();
                var n = s + 1;
                if ('object' == typeof e && 'length' in e) {
                    for (var r = 0; r < e.length; r += 1) e[r] && a.prepend(e[r]);
                    n = s + e.length;
                } else a.prepend(e);
                i.loop && t.loopCreate(), (i.observer && te.observer) ||
                    t.update(), t.slideTo(n, 0, !1);
            },
            addSlide: function(e, t) {
                var i = this,
                    a = i.$wrapperEl,
                    s = i.params,
                    n = i.activeIndex;
                s.loop &&
                    (
                        (n -= i.loopedSlides),
                        i.loopDestroy(),
                        (i.slides = a.children('.' + s.slideClass))
                    );
                var r = i.slides.length;
                if (e <= 0) i.prependSlide(t);
                else if (r <= e) i.appendSlide(t);
                else {
                    for (var o = e < n ? n + 1 : n, l = [], d = r - 1; e <= d; d -= 1) {
                        var p = i.slides.eq(d);
                        p.remove(), l.unshift(p);
                    }
                    if ('object' == typeof t && 'length' in t) {
                        for (var u = 0; u < t.length; u += 1) t[u] && a.append(t[u]);
                        o = e < n ? n + t.length : n;
                    } else a.append(t);
                    for (var c = 0; c < l.length; c += 1) a.append(l[c]);
                    s.loop && i.loopCreate(), (s.observer && te.observer) ||
                        i.update(), s.loop
                        ? i.slideTo(o + i.loopedSlides, 0, !1)
                        : i.slideTo(o, 0, !1);
                }
            },
            removeSlide: function(e) {
                var t = this,
                    i = t.params,
                    a = t.$wrapperEl,
                    s = t.activeIndex;
                i.loop &&
                    (
                        (s -= t.loopedSlides),
                        t.loopDestroy(),
                        (t.slides = a.children('.' + i.slideClass))
                    );
                var n,
                    r = s;
                if ('object' == typeof e && 'length' in e) {
                    for (var o = 0; o < e.length; o += 1)
                        (n = e[o]), t.slides[n] && t.slides.eq(n).remove(), n < r &&
                            (r -= 1);
                    r = Math.max(r, 0);
                } else
                    (n = e), t.slides[n] && t.slides.eq(n).remove(), n < r &&
                        (r -= 1), (r = Math.max(r, 0));
                i.loop && t.loopCreate(), (i.observer && te.observer) ||
                    t.update(), i.loop
                    ? t.slideTo(r + t.loopedSlides, 0, !1)
                    : t.slideTo(r, 0, !1);
            },
            removeAllSlides: function() {
                for (var e = [], t = 0; t < this.slides.length; t += 1) e.push(t);
                this.removeSlide(e);
            }
        },
        w = (function() {
            var e = Z.navigator.userAgent,
                t = {
                    ios: !1,
                    android: !1,
                    androidChrome: !1,
                    desktop: !1,
                    windows: !1,
                    iphone: !1,
                    ipod: !1,
                    ipad: !1,
                    cordova: Z.cordova || Z.phonegap,
                    phonegap: Z.cordova || Z.phonegap
                },
                i = e.match(/(Windows Phone);?[\s\/]+([\d.]+)?/),
                a = e.match(/(Android);?[\s\/]+([\d.]+)?/),
                s = e.match(/(iPad).*OS\s([\d_]+)/),
                n = e.match(/(iPod)(.*OS\s([\d_]+))?/),
                r = !s && e.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
            if (
                (
                    i && ((t.os = 'windows'), (t.osVersion = i[2]), (t.windows = !0)),
                    a &&
                        !i &&
                        (
                            (t.os = 'android'),
                            (t.osVersion = a[2]),
                            (t.android = !0),
                            (t.androidChrome = 0 <= e.toLowerCase().indexOf('chrome'))
                        ),
                    (s || r || n) && ((t.os = 'ios'), (t.ios = !0)),
                    r && !n && ((t.osVersion = r[2].replace(/_/g, '.')), (t.iphone = !0)),
                    s && ((t.osVersion = s[2].replace(/_/g, '.')), (t.ipad = !0)),
                    n &&
                        (
                            (t.osVersion = n[3] ? n[3].replace(/_/g, '.') : null),
                            (t.iphone = !0)
                        ),
                    t.ios &&
                        t.osVersion &&
                        0 <= e.indexOf('Version/') &&
                        '10' === t.osVersion.split('.')[0] &&
                        (t.osVersion = e
                            .toLowerCase()
                            .split('version/')[1]
                            .split(' ')[0]),
                    (t.desktop = !(t.os || t.android || t.webView)),
                    (t.webView = (r || s || n) && e.match(/.*AppleWebKit(?!.*Safari)/i)),
                    t.os && 'ios' === t.os
                )
            ) {
                var o = t.osVersion.split('.'),
                    l = f.querySelector('meta[name="viewport"]');
                t.minimalUi =
                    !t.webView &&
                    (n || r) &&
                    (1 * o[0] == 7 ? 1 <= 1 * o[1] : 7 < 1 * o[0]) &&
                    l &&
                    0 <= l.getAttribute('content').indexOf('minimal-ui');
            }
            return (t.pixelRatio = Z.devicePixelRatio || 1), t;
        })();
    function y() {
        var e = this,
            t = e.params,
            i = e.el;
        if (!i || 0 !== i.offsetWidth) {
            t.breakpoints && e.setBreakpoint();
            var a = e.allowSlideNext,
                s = e.allowSlidePrev,
                n = e.snapGrid;
            if (
                (
                    (e.allowSlideNext = !0),
                    (e.allowSlidePrev = !0),
                    e.updateSize(),
                    e.updateSlides(),
                    t.freeMode
                )
            ) {
                var r = Math.min(
                    Math.max(e.translate, e.maxTranslate()),
                    e.minTranslate()
                );
                e.setTranslate(
                    r
                ), e.updateActiveIndex(), e.updateSlidesClasses(), t.autoHeight &&
                    e.updateAutoHeight();
            } else
                e.updateSlidesClasses(), ('auto' === t.slidesPerView ||
                    1 < t.slidesPerView) &&
                e.isEnd &&
                !e.params.centeredSlides
                    ? e.slideTo(e.slides.length - 1, 0, !1, !0)
                    : e.slideTo(e.activeIndex, 0, !1, !0);
            e.autoplay &&
                e.autoplay.running &&
                e.autoplay.paused &&
                e.autoplay.run(), (e.allowSlidePrev = s), (e.allowSlideNext = a), e.params
                .watchOverflow &&
                n !== e.snapGrid &&
                e.checkOverflow();
        }
    }
    var b = {
            init: !0,
            direction: 'horizontal',
            touchEventsTarget: 'container',
            initialSlide: 0,
            speed: 300,
            preventInteractionOnTransition: !1,
            edgeSwipeDetection: !1,
            edgeSwipeThreshold: 20,
            freeMode: !1,
            freeModeMomentum: !0,
            freeModeMomentumRatio: 1,
            freeModeMomentumBounce: !0,
            freeModeMomentumBounceRatio: 1,
            freeModeMomentumVelocityRatio: 1,
            freeModeSticky: !1,
            freeModeMinimumVelocity: 0.02,
            autoHeight: !1,
            setWrapperSize: !1,
            virtualTranslate: !1,
            effect: 'slide',
            breakpoints: void 0,
            breakpointsInverse: !1,
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerColumnFill: 'column',
            slidesPerGroup: 1,
            centeredSlides: !1,
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
            normalizeSlideIndex: !0,
            centerInsufficientSlides: !1,
            watchOverflow: !1,
            roundLengths: !1,
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: !0,
            shortSwipes: !0,
            longSwipes: !0,
            longSwipesRatio: 0.5,
            longSwipesMs: 300,
            followFinger: !0,
            allowTouchMove: !0,
            threshold: 0,
            touchMoveStopPropagation: !0,
            touchStartPreventDefault: !0,
            touchStartForcePreventDefault: !1,
            touchReleaseOnEdges: !1,
            uniqueNavElements: !0,
            resistance: !0,
            resistanceRatio: 0.85,
            watchSlidesProgress: !1,
            watchSlidesVisibility: !1,
            grabCursor: !1,
            preventClicks: !0,
            preventClicksPropagation: !0,
            slideToClickedSlide: !1,
            preloadImages: !0,
            updateOnImagesReady: !0,
            loop: !1,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            loopFillGroupWithBlank: !1,
            allowSlidePrev: !0,
            allowSlideNext: !0,
            swipeHandler: null,
            noSwiping: !0,
            noSwipingClass: 'swiper-no-swiping',
            noSwipingSelector: null,
            passiveListeners: !0,
            containerModifierClass: 'swiper-container-',
            slideClass: 'swiper-slide',
            slideBlankClass: 'swiper-slide-invisible-blank',
            slideActiveClass: 'swiper-slide-active',
            slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
            slideVisibleClass: 'swiper-slide-visible',
            slideDuplicateClass: 'swiper-slide-duplicate',
            slideNextClass: 'swiper-slide-next',
            slideDuplicateNextClass: 'swiper-slide-duplicate-next',
            slidePrevClass: 'swiper-slide-prev',
            slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
            wrapperClass: 'swiper-wrapper',
            runCallbacksOnInit: !0
        },
        x = {
            update: p,
            translate: u,
            transition: c,
            slide: h,
            loop: v,
            grabCursor: m,
            manipulation: g,
            events: {
                attachEvents: function() {
                    var e = this,
                        t = e.params,
                        i = e.touchEvents,
                        a = e.el,
                        s = e.wrapperEl;
                    (e.onTouchStart = function(e) {
                        var t = this,
                            i = t.touchEventsData,
                            a = t.params,
                            s = t.touches;
                        if (!t.animating || !a.preventInteractionOnTransition) {
                            var n = e;
                            if (
                                (
                                    n.originalEvent && (n = n.originalEvent),
                                    (i.isTouchEvent = 'touchstart' === n.type),
                                    (i.isTouchEvent ||
                                        !('which' in n) ||
                                        3 !== n.which) &&
                                        !(
                                            (!i.isTouchEvent &&
                                                'button' in n &&
                                                0 < n.button) ||
                                            (i.isTouched && i.isMoved)
                                        )
                                )
                            )
                                if (
                                    a.noSwiping &&
                                    C(n.target).closest(
                                        a.noSwipingSelector
                                            ? a.noSwipingSelector
                                            : '.' + a.noSwipingClass
                                    )[0]
                                )
                                    t.allowClick = !0;
                                else if (
                                    !a.swipeHandler ||
                                    C(n).closest(a.swipeHandler)[0]
                                ) {
                                    (s.currentX =
                                        'touchstart' === n.type
                                            ? n.targetTouches[0].pageX
                                            : n.pageX), (s.currentY =
                                        'touchstart' === n.type
                                            ? n.targetTouches[0].pageY
                                            : n.pageY);
                                    var r = s.currentX,
                                        o = s.currentY,
                                        l =
                                            a.edgeSwipeDetection ||
                                            a.iOSEdgeSwipeDetection,
                                        d =
                                            a.edgeSwipeThreshold ||
                                            a.iOSEdgeSwipeThreshold;
                                    if (!l || !(r <= d || r >= Z.screen.width - d)) {
                                        if (
                                            (
                                                ee.extend(i, {
                                                    isTouched: !0,
                                                    isMoved: !1,
                                                    allowTouchCallbacks: !0,
                                                    isScrolling: void 0,
                                                    startMoving: void 0
                                                }),
                                                (s.startX = r),
                                                (s.startY = o),
                                                (i.touchStartTime = ee.now()),
                                                (t.allowClick = !0),
                                                t.updateSize(),
                                                (t.swipeDirection = void 0),
                                                0 < a.threshold &&
                                                    (i.allowThresholdMove = !1),
                                                'touchstart' !== n.type
                                            )
                                        ) {
                                            var p = !0;
                                            C(n.target).is(i.formElements) &&
                                                (p = !1), f.activeElement &&
                                                C(f.activeElement).is(i.formElements) &&
                                                f.activeElement !== n.target &&
                                                f.activeElement.blur();
                                            var u =
                                                p &&
                                                t.allowTouchMove &&
                                                a.touchStartPreventDefault;
                                            (a.touchStartForcePreventDefault || u) &&
                                                n.preventDefault();
                                        }
                                        t.emit('touchStart', n);
                                    }
                                }
                        }
                    }.bind(e)), (e.onTouchMove = function(e) {
                        var t = this,
                            i = t.touchEventsData,
                            a = t.params,
                            s = t.touches,
                            n = t.rtlTranslate,
                            r = e;
                        if ((r.originalEvent && (r = r.originalEvent), i.isTouched)) {
                            if (!i.isTouchEvent || 'mousemove' !== r.type) {
                                var o =
                                        'touchmove' === r.type
                                            ? r.targetTouches[0].pageX
                                            : r.pageX,
                                    l =
                                        'touchmove' === r.type
                                            ? r.targetTouches[0].pageY
                                            : r.pageY;
                                if (r.preventedByNestedSwiper)
                                    return (s.startX = o), void (s.startY = l);
                                if (!t.allowTouchMove)
                                    return (t.allowClick = !1), void (
                                        i.isTouched &&
                                        (
                                            ee.extend(s, {
                                                startX: o,
                                                startY: l,
                                                currentX: o,
                                                currentY: l
                                            }),
                                            (i.touchStartTime = ee.now())
                                        )
                                    );
                                if (i.isTouchEvent && a.touchReleaseOnEdges && !a.loop)
                                    if (t.isVertical()) {
                                        if (
                                            (l < s.startY &&
                                                t.translate <= t.maxTranslate()) ||
                                            (l > s.startY &&
                                                t.translate >= t.minTranslate())
                                        )
                                            return (i.isTouched = !1), void (i.isMoved = !1);
                                    } else if (
                                        (o < s.startX &&
                                            t.translate <= t.maxTranslate()) ||
                                        (o > s.startX && t.translate >= t.minTranslate())
                                    )
                                        return;
                                if (
                                    i.isTouchEvent &&
                                    f.activeElement &&
                                    r.target === f.activeElement &&
                                    C(r.target).is(i.formElements)
                                )
                                    return (i.isMoved = !0), void (t.allowClick = !1);
                                if (
                                    (
                                        i.allowTouchCallbacks && t.emit('touchMove', r),
                                        !(r.targetTouches && 1 < r.targetTouches.length)
                                    )
                                ) {
                                    (s.currentX = o), (s.currentY = l);
                                    var d = s.currentX - s.startX,
                                        p = s.currentY - s.startY;
                                    if (
                                        !(
                                            t.params.threshold &&
                                            Math.sqrt(Math.pow(d, 2) + Math.pow(p, 2)) <
                                                t.params.threshold
                                        )
                                    ) {
                                        var u;
                                        if (void 0 === i.isScrolling)
                                            (t.isHorizontal() &&
                                                s.currentY === s.startY) ||
                                            (t.isVertical() && s.currentX === s.startX)
                                                ? (i.isScrolling = !1)
                                                : 25 <= d * d + p * p &&
                                                  (
                                                      (u =
                                                          180 *
                                                          Math.atan2(
                                                              Math.abs(p),
                                                              Math.abs(d)
                                                          ) /
                                                          Math.PI),
                                                      (i.isScrolling = t.isHorizontal()
                                                          ? u > a.touchAngle
                                                          : 90 - u > a.touchAngle)
                                                  );
                                        if (
                                            (
                                                i.isScrolling &&
                                                    t.emit('touchMoveOpposite', r),
                                                void 0 === i.startMoving &&
                                                    ((s.currentX === s.startX &&
                                                        s.currentY === s.startY) ||
                                                        (i.startMoving = !0)),
                                                i.isScrolling
                                            )
                                        )
                                            i.isTouched = !1;
                                        else if (i.startMoving) {
                                            (t.allowClick = !1), r.preventDefault(), a.touchMoveStopPropagation &&
                                                !a.nested &&
                                                r.stopPropagation(), i.isMoved ||
                                                (
                                                    a.loop && t.loopFix(),
                                                    (i.startTranslate = t.getTranslate()),
                                                    t.setTransition(0),
                                                    t.animating &&
                                                        t.$wrapperEl.trigger(
                                                            'webkitTransitionEnd transitionend'
                                                        ),
                                                    (i.allowMomentumBounce = !1),
                                                    !a.grabCursor ||
                                                        (!0 !== t.allowSlideNext &&
                                                            !0 !== t.allowSlidePrev) ||
                                                        t.setGrabCursor(!0),
                                                    t.emit('sliderFirstMove', r)
                                                ), t.emit(
                                                'sliderMove',
                                                r
                                            ), (i.isMoved = !0);
                                            var c = t.isHorizontal() ? d : p;
                                            (s.diff = c), (c *= a.touchRatio), n &&
                                                (c = -c), (t.swipeDirection =
                                                0 < c
                                                    ? 'prev'
                                                    : 'next'), (i.currentTranslate =
                                                c + i.startTranslate);
                                            var h = !0,
                                                v = a.resistanceRatio;
                                            if (
                                                (
                                                    a.touchReleaseOnEdges && (v = 0),
                                                    0 < c &&
                                                    i.currentTranslate > t.minTranslate()
                                                        ? (
                                                              (h = !1),
                                                              a.resistance &&
                                                                  (i.currentTranslate =
                                                                      t.minTranslate() -
                                                                      1 +
                                                                      Math.pow(
                                                                          -t.minTranslate() +
                                                                              i.startTranslate +
                                                                              c,
                                                                          v
                                                                      ))
                                                          )
                                                        : c < 0 &&
                                                          i.currentTranslate <
                                                              t.maxTranslate() &&
                                                          (
                                                              (h = !1),
                                                              a.resistance &&
                                                                  (i.currentTranslate =
                                                                      t.maxTranslate() +
                                                                      1 -
                                                                      Math.pow(
                                                                          t.maxTranslate() -
                                                                              i.startTranslate -
                                                                              c,
                                                                          v
                                                                      ))
                                                          ),
                                                    h && (r.preventedByNestedSwiper = !0),
                                                    !t.allowSlideNext &&
                                                        'next' === t.swipeDirection &&
                                                        i.currentTranslate <
                                                            i.startTranslate &&
                                                        (i.currentTranslate =
                                                            i.startTranslate),
                                                    !t.allowSlidePrev &&
                                                        'prev' === t.swipeDirection &&
                                                        i.currentTranslate >
                                                            i.startTranslate &&
                                                        (i.currentTranslate =
                                                            i.startTranslate),
                                                    0 < a.threshold
                                                )
                                            ) {
                                                if (
                                                    !(
                                                        Math.abs(c) > a.threshold ||
                                                        i.allowThresholdMove
                                                    )
                                                )
                                                    return void (i.currentTranslate =
                                                        i.startTranslate);
                                                if (!i.allowThresholdMove)
                                                    return (i.allowThresholdMove = !0), (s.startX =
                                                        s.currentX), (s.startY =
                                                        s.currentY), (i.currentTranslate =
                                                        i.startTranslate), void (s.diff = t.isHorizontal()
                                                        ? s.currentX - s.startX
                                                        : s.currentY - s.startY);
                                            }
                                            a.followFinger &&
                                                (
                                                    (a.freeMode ||
                                                        a.watchSlidesProgress ||
                                                        a.watchSlidesVisibility) &&
                                                        (
                                                            t.updateActiveIndex(),
                                                            t.updateSlidesClasses()
                                                        ),
                                                    a.freeMode &&
                                                        (
                                                            0 === i.velocities.length &&
                                                                i.velocities.push({
                                                                    position:
                                                                        s[
                                                                            t.isHorizontal()
                                                                                ? 'startX'
                                                                                : 'startY'
                                                                        ],
                                                                    time: i.touchStartTime
                                                                }),
                                                            i.velocities.push({
                                                                position:
                                                                    s[
                                                                        t.isHorizontal()
                                                                            ? 'currentX'
                                                                            : 'currentY'
                                                                    ],
                                                                time: ee.now()
                                                            })
                                                        ),
                                                    t.updateProgress(i.currentTranslate),
                                                    t.setTranslate(i.currentTranslate)
                                                );
                                        }
                                    }
                                }
                            }
                        } else
                            i.startMoving &&
                                i.isScrolling &&
                                t.emit('touchMoveOpposite', r);
                    }.bind(e)), (e.onTouchEnd = function(e) {
                        var t = this,
                            i = t.touchEventsData,
                            a = t.params,
                            s = t.touches,
                            n = t.rtlTranslate,
                            r = t.$wrapperEl,
                            o = t.slidesGrid,
                            l = t.snapGrid,
                            d = e;
                        if (
                            (
                                d.originalEvent && (d = d.originalEvent),
                                i.allowTouchCallbacks && t.emit('touchEnd', d),
                                (i.allowTouchCallbacks = !1),
                                !i.isTouched
                            )
                        )
                            return i.isMoved &&
                                a.grabCursor &&
                                t.setGrabCursor(
                                    !1
                                ), (i.isMoved = !1), void (i.startMoving = !1);
                        a.grabCursor &&
                            i.isMoved &&
                            i.isTouched &&
                            (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) &&
                            t.setGrabCursor(!1);
                        var p,
                            u = ee.now(),
                            c = u - i.touchStartTime;
                        if (
                            (
                                t.allowClick &&
                                    (
                                        t.updateClickedSlide(d),
                                        t.emit('tap', d),
                                        c < 300 &&
                                            300 < u - i.lastClickTime &&
                                            (
                                                i.clickTimeout &&
                                                    clearTimeout(i.clickTimeout),
                                                (i.clickTimeout = ee.nextTick(function() {
                                                    t &&
                                                        !t.destroyed &&
                                                        t.emit('click', d);
                                                }, 300))
                                            ),
                                        c < 300 &&
                                            u - i.lastClickTime < 300 &&
                                            (
                                                i.clickTimeout &&
                                                    clearTimeout(i.clickTimeout),
                                                t.emit('doubleTap', d)
                                            )
                                    ),
                                (i.lastClickTime = ee.now()),
                                ee.nextTick(function() {
                                    t.destroyed || (t.allowClick = !0);
                                }),
                                !i.isTouched ||
                                    !i.isMoved ||
                                    !t.swipeDirection ||
                                    0 === s.diff ||
                                    i.currentTranslate === i.startTranslate
                            )
                        )
                            return (i.isTouched = !1), (i.isMoved = !1), void (i.startMoving = !1);
                        if (
                            (
                                (i.isTouched = !1),
                                (i.isMoved = !1),
                                (i.startMoving = !1),
                                (p = a.followFinger
                                    ? n ? t.translate : -t.translate
                                    : -i.currentTranslate),
                                a.freeMode
                            )
                        ) {
                            if (p < -t.minTranslate())
                                return void t.slideTo(t.activeIndex);
                            if (p > -t.maxTranslate())
                                return void (t.slides.length < l.length
                                    ? t.slideTo(l.length - 1)
                                    : t.slideTo(t.slides.length - 1));
                            if (a.freeModeMomentum) {
                                if (1 < i.velocities.length) {
                                    var h = i.velocities.pop(),
                                        v = i.velocities.pop(),
                                        f = h.position - v.position,
                                        m = h.time - v.time;
                                    (t.velocity = f / m), (t.velocity /= 2), Math.abs(
                                        t.velocity
                                    ) < a.freeModeMinimumVelocity &&
                                        (t.velocity = 0), (150 < m ||
                                        300 < ee.now() - h.time) &&
                                        (t.velocity = 0);
                                } else t.velocity = 0;
                                (t.velocity *=
                                    a.freeModeMomentumVelocityRatio), (i.velocities.length = 0);
                                var g = 1e3 * a.freeModeMomentumRatio,
                                    w = t.velocity * g,
                                    y = t.translate + w;
                                n && (y = -y);
                                var b,
                                    C,
                                    x = !1,
                                    T =
                                        20 *
                                        Math.abs(t.velocity) *
                                        a.freeModeMomentumBounceRatio;
                                if (y < t.maxTranslate())
                                    a.freeModeMomentumBounce
                                        ? (
                                              y + t.maxTranslate() < -T &&
                                                  (y = t.maxTranslate() - T),
                                              (b = t.maxTranslate()),
                                              (x = !0),
                                              (i.allowMomentumBounce = !0)
                                          )
                                        : (y = t.maxTranslate()), a.loop &&
                                        a.centeredSlides &&
                                        (C = !0);
                                else if (y > t.minTranslate())
                                    a.freeModeMomentumBounce
                                        ? (
                                              y - t.minTranslate() > T &&
                                                  (y = t.minTranslate() + T),
                                              (b = t.minTranslate()),
                                              (x = !0),
                                              (i.allowMomentumBounce = !0)
                                          )
                                        : (y = t.minTranslate()), a.loop &&
                                        a.centeredSlides &&
                                        (C = !0);
                                else if (a.freeModeSticky) {
                                    for (var S, E = 0; E < l.length; E += 1)
                                        if (l[E] > -y) {
                                            S = E;
                                            break;
                                        }
                                    y = -(y =
                                        Math.abs(l[S] - y) < Math.abs(l[S - 1] - y) ||
                                        'next' === t.swipeDirection
                                            ? l[S]
                                            : l[S - 1]);
                                }
                                if (
                                    (
                                        C &&
                                            t.once('transitionEnd', function() {
                                                t.loopFix();
                                            }),
                                        0 !== t.velocity
                                    )
                                )
                                    g = n
                                        ? Math.abs((-y - t.translate) / t.velocity)
                                        : Math.abs((y - t.translate) / t.velocity);
                                else if (a.freeModeSticky) return void t.slideToClosest();
                                a.freeModeMomentumBounce && x
                                    ? (
                                          t.updateProgress(b),
                                          t.setTransition(g),
                                          t.setTranslate(y),
                                          t.transitionStart(!0, t.swipeDirection),
                                          (t.animating = !0),
                                          r.transitionEnd(function() {
                                              t &&
                                                  !t.destroyed &&
                                                  i.allowMomentumBounce &&
                                                  (
                                                      t.emit('momentumBounce'),
                                                      t.setTransition(a.speed),
                                                      t.setTranslate(b),
                                                      r.transitionEnd(function() {
                                                          t &&
                                                              !t.destroyed &&
                                                              t.transitionEnd();
                                                      })
                                                  );
                                          })
                                      )
                                    : t.velocity
                                      ? (
                                            t.updateProgress(y),
                                            t.setTransition(g),
                                            t.setTranslate(y),
                                            t.transitionStart(!0, t.swipeDirection),
                                            t.animating ||
                                                (
                                                    (t.animating = !0),
                                                    r.transitionEnd(function() {
                                                        t &&
                                                            !t.destroyed &&
                                                            t.transitionEnd();
                                                    })
                                                )
                                        )
                                      : t.updateProgress(
                                            y
                                        ), t.updateActiveIndex(), t.updateSlidesClasses();
                            } else if (a.freeModeSticky) return void t.slideToClosest();
                            (!a.freeModeMomentum || c >= a.longSwipesMs) &&
                                (
                                    t.updateProgress(),
                                    t.updateActiveIndex(),
                                    t.updateSlidesClasses()
                                );
                        } else {
                            for (
                                var M = 0, P = t.slidesSizesGrid[0], k = 0;
                                k < o.length;
                                k += a.slidesPerGroup
                            )
                                void 0 !== o[k + a.slidesPerGroup]
                                    ? p >= o[k] &&
                                      p < o[k + a.slidesPerGroup] &&
                                      (P = o[(M = k) + a.slidesPerGroup] - o[k])
                                    : p >= o[k] &&
                                      ((M = k), (P = o[o.length - 1] - o[o.length - 2]));
                            var L = (p - o[M]) / P;
                            if (c > a.longSwipesMs) {
                                if (!a.longSwipes) return void t.slideTo(t.activeIndex);
                                'next' === t.swipeDirection &&
                                    (L >= a.longSwipesRatio
                                        ? t.slideTo(M + a.slidesPerGroup)
                                        : t.slideTo(M)), 'prev' === t.swipeDirection &&
                                    (L > 1 - a.longSwipesRatio
                                        ? t.slideTo(M + a.slidesPerGroup)
                                        : t.slideTo(M));
                            } else {
                                if (!a.shortSwipes) return void t.slideTo(t.activeIndex);
                                'next' === t.swipeDirection &&
                                    t.slideTo(M + a.slidesPerGroup), 'prev' ===
                                    t.swipeDirection && t.slideTo(M);
                            }
                        }
                    }.bind(e)), (e.onClick = function(e) {
                        this.allowClick ||
                            (
                                this.params.preventClicks && e.preventDefault(),
                                this.params.preventClicksPropagation &&
                                    this.animating &&
                                    (e.stopPropagation(), e.stopImmediatePropagation())
                            );
                    }.bind(e));
                    var n = 'container' === t.touchEventsTarget ? a : s,
                        r = !!t.nested;
                    if (te.touch || (!te.pointerEvents && !te.prefixedPointerEvents)) {
                        if (te.touch) {
                            var o = !(
                                'touchstart' !== i.start ||
                                !te.passiveListener ||
                                !t.passiveListeners
                            ) && { passive: !0, capture: !1 };
                            n.addEventListener(
                                i.start,
                                e.onTouchStart,
                                o
                            ), n.addEventListener(
                                i.move,
                                e.onTouchMove,
                                te.passiveListener ? { passive: !1, capture: r } : r
                            ), n.addEventListener(i.end, e.onTouchEnd, o);
                        }
                        ((t.simulateTouch && !w.ios && !w.android) ||
                            (t.simulateTouch && !te.touch && w.ios)) &&
                            (
                                n.addEventListener('mousedown', e.onTouchStart, !1),
                                f.addEventListener('mousemove', e.onTouchMove, r),
                                f.addEventListener('mouseup', e.onTouchEnd, !1)
                            );
                    } else
                        n.addEventListener(
                            i.start,
                            e.onTouchStart,
                            !1
                        ), f.addEventListener(
                            i.move,
                            e.onTouchMove,
                            r
                        ), f.addEventListener(i.end, e.onTouchEnd, !1);
                    (t.preventClicks || t.preventClicksPropagation) &&
                        n.addEventListener('click', e.onClick, !0), e.on(
                        w.ios || w.android
                            ? 'resize orientationchange observerUpdate'
                            : 'resize observerUpdate',
                        y,
                        !0
                    );
                },
                detachEvents: function() {
                    var e = this,
                        t = e.params,
                        i = e.touchEvents,
                        a = e.el,
                        s = e.wrapperEl,
                        n = 'container' === t.touchEventsTarget ? a : s,
                        r = !!t.nested;
                    if (te.touch || (!te.pointerEvents && !te.prefixedPointerEvents)) {
                        if (te.touch) {
                            var o = !(
                                'onTouchStart' !== i.start ||
                                !te.passiveListener ||
                                !t.passiveListeners
                            ) && { passive: !0, capture: !1 };
                            n.removeEventListener(
                                i.start,
                                e.onTouchStart,
                                o
                            ), n.removeEventListener(
                                i.move,
                                e.onTouchMove,
                                r
                            ), n.removeEventListener(i.end, e.onTouchEnd, o);
                        }
                        ((t.simulateTouch && !w.ios && !w.android) ||
                            (t.simulateTouch && !te.touch && w.ios)) &&
                            (
                                n.removeEventListener('mousedown', e.onTouchStart, !1),
                                f.removeEventListener('mousemove', e.onTouchMove, r),
                                f.removeEventListener('mouseup', e.onTouchEnd, !1)
                            );
                    } else
                        n.removeEventListener(
                            i.start,
                            e.onTouchStart,
                            !1
                        ), f.removeEventListener(
                            i.move,
                            e.onTouchMove,
                            r
                        ), f.removeEventListener(i.end, e.onTouchEnd, !1);
                    (t.preventClicks || t.preventClicksPropagation) &&
                        n.removeEventListener('click', e.onClick, !0), e.off(
                        w.ios || w.android
                            ? 'resize orientationchange observerUpdate'
                            : 'resize observerUpdate',
                        y
                    );
                }
            },
            breakpoints: {
                setBreakpoint: function() {
                    var e = this,
                        t = e.activeIndex,
                        i = e.initialized,
                        a = e.loopedSlides;
                    void 0 === a && (a = 0);
                    var s = e.params,
                        n = s.breakpoints;
                    if (n && (!n || 0 !== Object.keys(n).length)) {
                        var r = e.getBreakpoint(n);
                        if (r && e.currentBreakpoint !== r) {
                            var o = r in n ? n[r] : void 0;
                            o &&
                                [
                                    'slidesPerView',
                                    'spaceBetween',
                                    'slidesPerGroup'
                                ].forEach(function(e) {
                                    var t = o[e];
                                    void 0 !== t &&
                                        (o[e] =
                                            'slidesPerView' !== e ||
                                            ('AUTO' !== t && 'auto' !== t)
                                                ? 'slidesPerView' === e
                                                  ? parseFloat(t)
                                                  : parseInt(t, 10)
                                                : 'auto');
                                });
                            var l = o || e.originalParams,
                                d = l.direction && l.direction !== s.direction,
                                p = s.loop && (l.slidesPerView !== s.slidesPerView || d);
                            d && i && e.changeDirection(), ee.extend(
                                e.params,
                                l
                            ), ee.extend(e, {
                                allowTouchMove: e.params.allowTouchMove,
                                allowSlideNext: e.params.allowSlideNext,
                                allowSlidePrev: e.params.allowSlidePrev
                            }), (e.currentBreakpoint = r), p &&
                                i &&
                                (
                                    e.loopDestroy(),
                                    e.loopCreate(),
                                    e.updateSlides(),
                                    e.slideTo(t - a + e.loopedSlides, 0, !1)
                                ), e.emit('breakpoint', l);
                        }
                    }
                },
                getBreakpoint: function(e) {
                    if (e) {
                        var t = !1,
                            i = [];
                        Object.keys(e).forEach(function(e) {
                            i.push(e);
                        }), i.sort(function(e, t) {
                            return parseInt(e, 10) - parseInt(t, 10);
                        });
                        for (var a = 0; a < i.length; a += 1) {
                            var s = i[a];
                            this.params.breakpointsInverse
                                ? s <= Z.innerWidth && (t = s)
                                : s >= Z.innerWidth && !t && (t = s);
                        }
                        return t || 'max';
                    }
                }
            },
            checkOverflow: {
                checkOverflow: function() {
                    var e = this,
                        t = e.isLocked;
                    (e.isLocked =
                        1 ===
                        e.snapGrid
                            .length), (e.allowSlideNext = !e.isLocked), (e.allowSlidePrev = !e.isLocked), t !==
                        e.isLocked && e.emit(e.isLocked ? 'lock' : 'unlock'), t &&
                        t !== e.isLocked &&
                        ((e.isEnd = !1), e.navigation.update());
                }
            },
            classes: {
                addClasses: function() {
                    var t = this.classNames,
                        i = this.params,
                        e = this.rtl,
                        a = this.$el,
                        s = [];
                    s.push('initialized'), s.push(i.direction), i.freeMode &&
                        s.push('free-mode'), te.flexbox ||
                        s.push('no-flexbox'), i.autoHeight && s.push('autoheight'), e &&
                        s.push('rtl'), 1 < i.slidesPerColumn &&
                        s.push('multirow'), w.android && s.push('android'), w.ios &&
                        s.push('ios'), (o.isIE || o.isEdge) &&
                        (te.pointerEvents || te.prefixedPointerEvents) &&
                        s.push('wp8-' + i.direction), s.forEach(function(e) {
                        t.push(i.containerModifierClass + e);
                    }), a.addClass(t.join(' '));
                },
                removeClasses: function() {
                    var e = this.$el,
                        t = this.classNames;
                    e.removeClass(t.join(' '));
                }
            },
            images: {
                loadImage: function(e, t, i, a, s, n) {
                    var r;
                    function o() {
                        n && n();
                    }
                    e.complete && s
                        ? o()
                        : t
                          ? (
                                ((r = new Z.Image()).onload = o),
                                (r.onerror = o),
                                a && (r.sizes = a),
                                i && (r.srcset = i),
                                t && (r.src = t)
                            )
                          : o();
                },
                preloadImages: function() {
                    var e = this;
                    function t() {
                        null != e &&
                            e &&
                            !e.destroyed &&
                            (
                                void 0 !== e.imagesLoaded && (e.imagesLoaded += 1),
                                e.imagesLoaded === e.imagesToLoad.length &&
                                    (
                                        e.params.updateOnImagesReady && e.update(),
                                        e.emit('imagesReady')
                                    )
                            );
                    }
                    e.imagesToLoad = e.$el.find('img');
                    for (var i = 0; i < e.imagesToLoad.length; i += 1) {
                        var a = e.imagesToLoad[i];
                        e.loadImage(
                            a,
                            a.currentSrc || a.getAttribute('src'),
                            a.srcset || a.getAttribute('srcset'),
                            a.sizes || a.getAttribute('sizes'),
                            !0,
                            t
                        );
                    }
                }
            }
        },
        T = {},
        S = (function(c) {
            function h() {
                for (var e, t, s, i = [], a = arguments.length; a--; )
                    i[a] = arguments[a];
                (s =
                    (s =
                        1 === i.length && i[0].constructor && i[0].constructor === Object
                            ? i[0]
                            : ((t = (e = i)[0]), e[1])) || {}), (s = ee.extend(
                    {},
                    s
                )), t && !s.el && (s.el = t), c.call(this, s), Object.keys(
                    x
                ).forEach(function(t) {
                    Object.keys(x[t]).forEach(function(e) {
                        h.prototype[e] || (h.prototype[e] = x[t][e]);
                    });
                });
                var n = this;
                void 0 === n.modules && (n.modules = {}), Object.keys(
                    n.modules
                ).forEach(function(e) {
                    var t = n.modules[e];
                    if (t.params) {
                        var i = Object.keys(t.params)[0],
                            a = t.params[i];
                        if ('object' != typeof a || null === a) return;
                        if (!(i in s && 'enabled' in a)) return;
                        !0 === s[i] && (s[i] = { enabled: !0 }), 'object' !=
                            typeof s[i] ||
                            'enabled' in s[i] ||
                            (s[i].enabled = !0), s[i] || (s[i] = { enabled: !1 });
                    }
                });
                var r = ee.extend({}, b);
                n.useModulesParams(r), (n.params = ee.extend(
                    {},
                    r,
                    T,
                    s
                )), (n.originalParams = ee.extend(
                    {},
                    n.params
                )), (n.passedParams = ee.extend({}, s));
                var o = (n.$ = C)(n.params.el);
                if ((t = o[0])) {
                    if (1 < o.length) {
                        var l = [];
                        return o.each(function(e, t) {
                            var i = ee.extend({}, s, { el: t });
                            l.push(new h(i));
                        }), l;
                    }
                    (t.swiper = n), o.data('swiper', n);
                    var d,
                        p,
                        u = o.children('.' + n.params.wrapperClass);
                    return ee.extend(n, {
                        $el: o,
                        el: t,
                        $wrapperEl: u,
                        wrapperEl: u[0],
                        classNames: [],
                        slides: C(),
                        slidesGrid: [],
                        snapGrid: [],
                        slidesSizesGrid: [],
                        isHorizontal: function() {
                            return 'horizontal' === n.params.direction;
                        },
                        isVertical: function() {
                            return 'vertical' === n.params.direction;
                        },
                        rtl:
                            'rtl' === t.dir.toLowerCase() || 'rtl' === o.css('direction'),
                        rtlTranslate:
                            'horizontal' === n.params.direction &&
                            ('rtl' === t.dir.toLowerCase() ||
                                'rtl' === o.css('direction')),
                        wrongRTL: '-webkit-box' === u.css('display'),
                        activeIndex: 0,
                        realIndex: 0,
                        isBeginning: !0,
                        isEnd: !1,
                        translate: 0,
                        previousTranslate: 0,
                        progress: 0,
                        velocity: 0,
                        animating: !1,
                        allowSlideNext: n.params.allowSlideNext,
                        allowSlidePrev: n.params.allowSlidePrev,
                        touchEvents: (
                            (d = ['touchstart', 'touchmove', 'touchend']),
                            (p = ['mousedown', 'mousemove', 'mouseup']),
                            te.pointerEvents
                                ? (p = ['pointerdown', 'pointermove', 'pointerup'])
                                : te.prefixedPointerEvents &&
                                  (p = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp']),
                            (n.touchEventsTouch = { start: d[0], move: d[1], end: d[2] }),
                            (n.touchEventsDesktop = {
                                start: p[0],
                                move: p[1],
                                end: p[2]
                            }),
                            te.touch || !n.params.simulateTouch
                                ? n.touchEventsTouch
                                : n.touchEventsDesktop
                        ),
                        touchEventsData: {
                            isTouched: void 0,
                            isMoved: void 0,
                            allowTouchCallbacks: void 0,
                            touchStartTime: void 0,
                            isScrolling: void 0,
                            currentTranslate: void 0,
                            startTranslate: void 0,
                            allowThresholdMove: void 0,
                            formElements:
                                'input, select, option, textarea, button, video',
                            lastClickTime: ee.now(),
                            clickTimeout: void 0,
                            velocities: [],
                            allowMomentumBounce: void 0,
                            isTouchEvent: void 0,
                            startMoving: void 0
                        },
                        allowClick: !0,
                        allowTouchMove: n.params.allowTouchMove,
                        touches: {
                            startX: 0,
                            startY: 0,
                            currentX: 0,
                            currentY: 0,
                            diff: 0
                        },
                        imagesToLoad: [],
                        imagesLoaded: 0
                    }), n.useModules(), n.params.init && n.init(), n;
                }
            }
            c && (h.__proto__ = c);
            var e = {
                extendedDefaults: { configurable: !0 },
                defaults: { configurable: !0 },
                Class: { configurable: !0 },
                $: { configurable: !0 }
            };
            return (((h.prototype = Object.create(
                c && c.prototype
            )).constructor = h).prototype.slidesPerViewDynamic = function() {
                var e = this,
                    t = e.params,
                    i = e.slides,
                    a = e.slidesGrid,
                    s = e.size,
                    n = e.activeIndex,
                    r = 1;
                if (t.centeredSlides) {
                    for (var o, l = i[n].swiperSlideSize, d = n + 1; d < i.length; d += 1)
                        i[d] &&
                            !o &&
                            ((r += 1), s < (l += i[d].swiperSlideSize) && (o = !0));
                    for (var p = n - 1; 0 <= p; p -= 1)
                        i[p] &&
                            !o &&
                            ((r += 1), s < (l += i[p].swiperSlideSize) && (o = !0));
                } else
                    for (var u = n + 1; u < i.length; u += 1) a[u] - a[n] < s && (r += 1);
                return r;
            }), (h.prototype.update = function() {
                var i = this;
                if (i && !i.destroyed) {
                    var e = i.snapGrid,
                        t = i.params;
                    t.breakpoints &&
                        i.setBreakpoint(), i.updateSize(), i.updateSlides(), i.updateProgress(), i.updateSlidesClasses(), i
                        .params.freeMode
                        ? (a(), i.params.autoHeight && i.updateAutoHeight())
                        : (('auto' === i.params.slidesPerView ||
                              1 < i.params.slidesPerView) &&
                          i.isEnd &&
                          !i.params.centeredSlides
                              ? i.slideTo(i.slides.length - 1, 0, !1, !0)
                              : i.slideTo(i.activeIndex, 0, !1, !0)) ||
                          a(), t.watchOverflow &&
                        e !== i.snapGrid &&
                        i.checkOverflow(), i.emit('update');
                }
                function a() {
                    var e = i.rtlTranslate ? -1 * i.translate : i.translate,
                        t = Math.min(Math.max(e, i.maxTranslate()), i.minTranslate());
                    i.setTranslate(t), i.updateActiveIndex(), i.updateSlidesClasses();
                }
            }), (h.prototype.changeDirection = function(i, e) {
                void 0 === e && (e = !0);
                var t = this,
                    a = t.params.direction;
                return (i = i || ('horizontal' === a ? 'vertical' : 'horizontal')) ===
                    a ||
                    ('horizontal' !== i && 'vertical' !== i) ||
                    (
                        t.$el
                            .removeClass(
                                '' + t.params.containerModifierClass + a + ' wp8-' + a
                            )
                            .addClass('' + t.params.containerModifierClass + i),
                        (o.isIE || o.isEdge) &&
                            (te.pointerEvents || te.prefixedPointerEvents) &&
                            t.$el.addClass(t.params.containerModifierClass + 'wp8-' + i),
                        (t.params.direction = i),
                        t.slides.each(function(e, t) {
                            'vertical' === i
                                ? (t.style.width = '')
                                : (t.style.height = '');
                        }),
                        t.emit('changeDirection'),
                        e && t.update()
                    ), t;
            }), (h.prototype.init = function() {
                var e = this;
                e.initialized ||
                    (
                        e.emit('beforeInit'),
                        e.params.breakpoints && e.setBreakpoint(),
                        e.addClasses(),
                        e.params.loop && e.loopCreate(),
                        e.updateSize(),
                        e.updateSlides(),
                        e.params.watchOverflow && e.checkOverflow(),
                        e.params.grabCursor && e.setGrabCursor(),
                        e.params.preloadImages && e.preloadImages(),
                        e.params.loop
                            ? e.slideTo(
                                  e.params.initialSlide + e.loopedSlides,
                                  0,
                                  e.params.runCallbacksOnInit
                              )
                            : e.slideTo(
                                  e.params.initialSlide,
                                  0,
                                  e.params.runCallbacksOnInit
                              ),
                        e.attachEvents(),
                        (e.initialized = !0),
                        e.emit('init')
                    );
            }), (h.prototype.destroy = function(e, t) {
                void 0 === e && (e = !0), void 0 === t && (t = !0);
                var i = this,
                    a = i.params,
                    s = i.$el,
                    n = i.$wrapperEl,
                    r = i.slides;
                return void 0 === i.params ||
                    i.destroyed ||
                    (
                        i.emit('beforeDestroy'),
                        (i.initialized = !1),
                        i.detachEvents(),
                        a.loop && i.loopDestroy(),
                        t &&
                            (
                                i.removeClasses(),
                                s.removeAttr('style'),
                                n.removeAttr('style'),
                                r &&
                                    r.length &&
                                    r
                                        .removeClass(
                                            [
                                                a.slideVisibleClass,
                                                a.slideActiveClass,
                                                a.slideNextClass,
                                                a.slidePrevClass
                                            ].join(' ')
                                        )
                                        .removeAttr('style')
                                        .removeAttr('data-swiper-slide-index')
                                        .removeAttr('data-swiper-column')
                                        .removeAttr('data-swiper-row')
                            ),
                        i.emit('destroy'),
                        Object.keys(i.eventsListeners).forEach(function(e) {
                            i.off(e);
                        }),
                        !1 !== e &&
                            (
                                (i.$el[0].swiper = null),
                                i.$el.data('swiper', null),
                                ee.deleteProps(i)
                            ),
                        (i.destroyed = !0)
                    ), null;
            }), (h.extendDefaults = function(e) {
                ee.extend(T, e);
            }), (e.extendedDefaults.get = function() {
                return T;
            }), (e.defaults.get = function() {
                return b;
            }), (e.Class.get = function() {
                return c;
            }), (e.$.get = function() {
                return C;
            }), Object.defineProperties(h, e), h;
        })(e),
        E = { name: 'device', proto: { device: w }, static: { device: w } },
        M = { name: 'support', proto: { support: te }, static: { support: te } },
        P = { name: 'browser', proto: { browser: o }, static: { browser: o } },
        k = {
            name: 'resize',
            create: function() {
                var e = this;
                ee.extend(e, {
                    resize: {
                        resizeHandler: function() {
                            e &&
                                !e.destroyed &&
                                e.initialized &&
                                (e.emit('beforeResize'), e.emit('resize'));
                        },
                        orientationChangeHandler: function() {
                            e &&
                                !e.destroyed &&
                                e.initialized &&
                                e.emit('orientationchange');
                        }
                    }
                });
            },
            on: {
                init: function() {
                    Z.addEventListener(
                        'resize',
                        this.resize.resizeHandler
                    ), Z.addEventListener(
                        'orientationchange',
                        this.resize.orientationChangeHandler
                    );
                },
                destroy: function() {
                    Z.removeEventListener(
                        'resize',
                        this.resize.resizeHandler
                    ), Z.removeEventListener(
                        'orientationchange',
                        this.resize.orientationChangeHandler
                    );
                }
            }
        },
        L = {
            func: Z.MutationObserver || Z.WebkitMutationObserver,
            attach: function(e, t) {
                void 0 === t && (t = {});
                var i = this,
                    a = new L.func(function(e) {
                        if (1 !== e.length) {
                            var t = function() {
                                i.emit('observerUpdate', e[0]);
                            };
                            Z.requestAnimationFrame
                                ? Z.requestAnimationFrame(t)
                                : Z.setTimeout(t, 0);
                        } else i.emit('observerUpdate', e[0]);
                    });
                a.observe(e, {
                    attributes: void 0 === t.attributes || t.attributes,
                    childList: void 0 === t.childList || t.childList,
                    characterData: void 0 === t.characterData || t.characterData
                }), i.observer.observers.push(a);
            },
            init: function() {
                var e = this;
                if (te.observer && e.params.observer) {
                    if (e.params.observeParents)
                        for (var t = e.$el.parents(), i = 0; i < t.length; i += 1)
                            e.observer.attach(t[i]);
                    e.observer.attach(e.$el[0], {
                        childList: e.params.observeSlideChildren
                    }), e.observer.attach(e.$wrapperEl[0], { attributes: !1 });
                }
            },
            destroy: function() {
                this.observer.observers.forEach(function(e) {
                    e.disconnect();
                }), (this.observer.observers = []);
            }
        },
        z = {
            update: function() {
                var e = this,
                    t = e.params.navigation;
                if (!e.params.loop) {
                    var i = e.navigation,
                        a = i.$nextEl,
                        s = i.$prevEl;
                    s &&
                        0 < s.length &&
                        (
                            e.isBeginning
                                ? s.addClass(t.disabledClass)
                                : s.removeClass(t.disabledClass),
                            s[
                                e.params.watchOverflow && e.isLocked
                                    ? 'addClass'
                                    : 'removeClass'
                            ](t.lockClass)
                        ), a &&
                        0 < a.length &&
                        (
                            e.isEnd
                                ? a.addClass(t.disabledClass)
                                : a.removeClass(t.disabledClass),
                            a[
                                e.params.watchOverflow && e.isLocked
                                    ? 'addClass'
                                    : 'removeClass'
                            ](t.lockClass)
                        );
                }
            },
            onPrevClick: function(e) {
                e.preventDefault(), (this.isBeginning && !this.params.loop) ||
                    this.slidePrev();
            },
            onNextClick: function(e) {
                e.preventDefault(), (this.isEnd && !this.params.loop) || this.slideNext();
            },
            init: function() {
                var e,
                    t,
                    i = this,
                    a = i.params.navigation;
                (a.nextEl || a.prevEl) &&
                    (
                        a.nextEl &&
                            (
                                (e = C(a.nextEl)),
                                i.params.uniqueNavElements &&
                                    'string' == typeof a.nextEl &&
                                    1 < e.length &&
                                    1 === i.$el.find(a.nextEl).length &&
                                    (e = i.$el.find(a.nextEl))
                            ),
                        a.prevEl &&
                            (
                                (t = C(a.prevEl)),
                                i.params.uniqueNavElements &&
                                    'string' == typeof a.prevEl &&
                                    1 < t.length &&
                                    1 === i.$el.find(a.prevEl).length &&
                                    (t = i.$el.find(a.prevEl))
                            ),
                        e && 0 < e.length && e.on('click', i.navigation.onNextClick),
                        t && 0 < t.length && t.on('click', i.navigation.onPrevClick),
                        ee.extend(i.navigation, {
                            $nextEl: e,
                            nextEl: e && e[0],
                            $prevEl: t,
                            prevEl: t && t[0]
                        })
                    );
            },
            destroy: function() {
                var e = this,
                    t = e.navigation,
                    i = t.$nextEl,
                    a = t.$prevEl;
                i &&
                    i.length &&
                    (
                        i.off('click', e.navigation.onNextClick),
                        i.removeClass(e.params.navigation.disabledClass)
                    ), a &&
                    a.length &&
                    (
                        a.off('click', e.navigation.onPrevClick),
                        a.removeClass(e.params.navigation.disabledClass)
                    );
            }
        },
        I = {
            update: function() {
                var e = this,
                    t = e.rtl,
                    s = e.params.pagination;
                if (
                    s.el &&
                    e.pagination.el &&
                    e.pagination.$el &&
                    0 !== e.pagination.$el.length
                ) {
                    var n,
                        i =
                            e.virtual && e.params.virtual.enabled
                                ? e.virtual.slides.length
                                : e.slides.length,
                        a = e.pagination.$el,
                        r = e.params.loop
                            ? Math.ceil(
                                  (i - 2 * e.loopedSlides) / e.params.slidesPerGroup
                              )
                            : e.snapGrid.length;
                    if (
                        (
                            e.params.loop
                                ? (
                                      (n = Math.ceil(
                                          (e.activeIndex - e.loopedSlides) /
                                              e.params.slidesPerGroup
                                      )) >
                                          i - 1 - 2 * e.loopedSlides &&
                                          (n -= i - 2 * e.loopedSlides),
                                      r - 1 < n && (n -= r),
                                      n < 0 &&
                                          'bullets' !== e.params.paginationType &&
                                          (n = r + n)
                                  )
                                : (n =
                                      void 0 !== e.snapIndex
                                          ? e.snapIndex
                                          : e.activeIndex || 0),
                            'bullets' === s.type &&
                                e.pagination.bullets &&
                                0 < e.pagination.bullets.length
                        )
                    ) {
                        var o,
                            l,
                            d,
                            p = e.pagination.bullets;
                        if (
                            (
                                s.dynamicBullets &&
                                    (
                                        (e.pagination.bulletSize = p
                                            .eq(0)
                                            [
                                                e.isHorizontal()
                                                    ? 'outerWidth'
                                                    : 'outerHeight'
                                            ](!0)),
                                        a.css(
                                            e.isHorizontal() ? 'width' : 'height',
                                            e.pagination.bulletSize *
                                                (s.dynamicMainBullets + 4) +
                                                'px'
                                        ),
                                        1 < s.dynamicMainBullets &&
                                            void 0 !== e.previousIndex &&
                                            (
                                                (e.pagination.dynamicBulletIndex +=
                                                    n - e.previousIndex),
                                                e.pagination.dynamicBulletIndex >
                                                s.dynamicMainBullets - 1
                                                    ? (e.pagination.dynamicBulletIndex =
                                                          s.dynamicMainBullets - 1)
                                                    : e.pagination.dynamicBulletIndex <
                                                          0 &&
                                                      (e.pagination.dynamicBulletIndex = 0)
                                            ),
                                        (o = n - e.pagination.dynamicBulletIndex),
                                        (d =
                                            ((l =
                                                o +
                                                (Math.min(
                                                    p.length,
                                                    s.dynamicMainBullets
                                                ) -
                                                    1)) +
                                                o) /
                                            2)
                                    ),
                                p.removeClass(
                                    s.bulletActiveClass +
                                        ' ' +
                                        s.bulletActiveClass +
                                        '-next ' +
                                        s.bulletActiveClass +
                                        '-next-next ' +
                                        s.bulletActiveClass +
                                        '-prev ' +
                                        s.bulletActiveClass +
                                        '-prev-prev ' +
                                        s.bulletActiveClass +
                                        '-main'
                                ),
                                1 < a.length
                            )
                        )
                            p.each(function(e, t) {
                                var i = C(t),
                                    a = i.index();
                                a === n &&
                                    i.addClass(
                                        s.bulletActiveClass
                                    ), s.dynamicBullets && (o <= a && a <= l && i.addClass(s.bulletActiveClass + '-main'), a === o && i.prev().addClass(s.bulletActiveClass + '-prev').prev().addClass(s.bulletActiveClass + '-prev-prev'), a === l && i.next().addClass(s.bulletActiveClass + '-next').next().addClass(s.bulletActiveClass + '-next-next'));
                            });
                        else if (
                            (p.eq(n).addClass(s.bulletActiveClass), s.dynamicBullets)
                        ) {
                            for (var u = p.eq(o), c = p.eq(l), h = o; h <= l; h += 1)
                                p.eq(h).addClass(s.bulletActiveClass + '-main');
                            u
                                .prev()
                                .addClass(s.bulletActiveClass + '-prev')
                                .prev()
                                .addClass(
                                    s.bulletActiveClass + '-prev-prev'
                                ), c
                                .next()
                                .addClass(s.bulletActiveClass + '-next')
                                .next()
                                .addClass(s.bulletActiveClass + '-next-next');
                        }
                        if (s.dynamicBullets) {
                            var v = Math.min(p.length, s.dynamicMainBullets + 4),
                                f =
                                    (e.pagination.bulletSize * v -
                                        e.pagination.bulletSize) /
                                        2 -
                                    d * e.pagination.bulletSize,
                                m = t ? 'right' : 'left';
                            p.css(e.isHorizontal() ? m : 'top', f + 'px');
                        }
                    }
                    if (
                        (
                            'fraction' === s.type &&
                                (
                                    a
                                        .find('.' + s.currentClass)
                                        .text(s.formatFractionCurrent(n + 1)),
                                    a
                                        .find('.' + s.totalClass)
                                        .text(s.formatFractionTotal(r))
                                ),
                            'progressbar' === s.type
                        )
                    ) {
                        var g;
                        g = s.progressbarOpposite
                            ? e.isHorizontal() ? 'vertical' : 'horizontal'
                            : e.isHorizontal() ? 'horizontal' : 'vertical';
                        var w = (n + 1) / r,
                            y = 1,
                            b = 1;
                        'horizontal' === g ? (y = w) : (b = w), a
                            .find('.' + s.progressbarFillClass)
                            .transform(
                                'translate3d(0,0,0) scaleX(' + y + ') scaleY(' + b + ')'
                            )
                            .transition(e.params.speed);
                    }
                    'custom' === s.type && s.renderCustom
                        ? (
                              a.html(s.renderCustom(e, n + 1, r)),
                              e.emit('paginationRender', e, a[0])
                          )
                        : e.emit('paginationUpdate', e, a[0]), a[
                        e.params.watchOverflow && e.isLocked ? 'addClass' : 'removeClass'
                    ](s.lockClass);
                }
            },
            render: function() {
                var e = this,
                    t = e.params.pagination;
                if (
                    t.el &&
                    e.pagination.el &&
                    e.pagination.$el &&
                    0 !== e.pagination.$el.length
                ) {
                    var i =
                            e.virtual && e.params.virtual.enabled
                                ? e.virtual.slides.length
                                : e.slides.length,
                        a = e.pagination.$el,
                        s = '';
                    if ('bullets' === t.type) {
                        for (
                            var n = e.params.loop
                                    ? Math.ceil(
                                          (i - 2 * e.loopedSlides) /
                                              e.params.slidesPerGroup
                                      )
                                    : e.snapGrid.length,
                                r = 0;
                            r < n;
                            r += 1
                        )
                            t.renderBullet
                                ? (s += t.renderBullet.call(e, r, t.bulletClass))
                                : (s +=
                                      '<' +
                                      t.bulletElement +
                                      ' class="' +
                                      t.bulletClass +
                                      '"></' +
                                      t.bulletElement +
                                      '>');
                        a.html(s), (e.pagination.bullets = a.find('.' + t.bulletClass));
                    }
                    'fraction' === t.type &&
                        (
                            (s = t.renderFraction
                                ? t.renderFraction.call(e, t.currentClass, t.totalClass)
                                : '<span class="' +
                                  t.currentClass +
                                  '"></span> / <span class="' +
                                  t.totalClass +
                                  '"></span>'),
                            a.html(s)
                        ), 'progressbar' === t.type &&
                        (
                            (s = t.renderProgressbar
                                ? t.renderProgressbar.call(e, t.progressbarFillClass)
                                : '<span class="' + t.progressbarFillClass + '"></span>'),
                            a.html(s)
                        ), 'custom' !== t.type &&
                        e.emit('paginationRender', e.pagination.$el[0]);
                }
            },
            init: function() {
                var i = this,
                    e = i.params.pagination;
                if (e.el) {
                    var t = C(e.el);
                    0 !== t.length &&
                        (
                            i.params.uniqueNavElements &&
                                'string' == typeof e.el &&
                                1 < t.length &&
                                1 === i.$el.find(e.el).length &&
                                (t = i.$el.find(e.el)),
                            'bullets' === e.type &&
                                e.clickable &&
                                t.addClass(e.clickableClass),
                            t.addClass(e.modifierClass + e.type),
                            'bullets' === e.type &&
                                e.dynamicBullets &&
                                (
                                    t.addClass(
                                        '' + e.modifierClass + e.type + '-dynamic'
                                    ),
                                    (i.pagination.dynamicBulletIndex = 0),
                                    e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)
                                ),
                            'progressbar' === e.type &&
                                e.progressbarOpposite &&
                                t.addClass(e.progressbarOppositeClass),
                            e.clickable &&
                                t.on('click', '.' + e.bulletClass, function(e) {
                                    e.preventDefault();
                                    var t = C(this).index() * i.params.slidesPerGroup;
                                    i.params.loop && (t += i.loopedSlides), i.slideTo(t);
                                }),
                            ee.extend(i.pagination, { $el: t, el: t[0] })
                        );
                }
            },
            destroy: function() {
                var e = this,
                    t = e.params.pagination;
                if (
                    t.el &&
                    e.pagination.el &&
                    e.pagination.$el &&
                    0 !== e.pagination.$el.length
                ) {
                    var i = e.pagination.$el;
                    i.removeClass(t.hiddenClass), i.removeClass(
                        t.modifierClass + t.type
                    ), e.pagination.bullets &&
                        e.pagination.bullets.removeClass(
                            t.bulletActiveClass
                        ), t.clickable && i.off('click', '.' + t.bulletClass);
                }
            }
        },
        O = {
            loadInSlide: function(e, l) {
                void 0 === l && (l = !0);
                var d = this,
                    p = d.params.lazy;
                if (void 0 !== e && 0 !== d.slides.length) {
                    var u =
                            d.virtual && d.params.virtual.enabled
                                ? d.$wrapperEl.children(
                                      '.' +
                                          d.params.slideClass +
                                          '[data-swiper-slide-index="' +
                                          e +
                                          '"]'
                                  )
                                : d.slides.eq(e),
                        t = u.find(
                            '.' +
                                p.elementClass +
                                ':not(.' +
                                p.loadedClass +
                                '):not(.' +
                                p.loadingClass +
                                ')'
                        );
                    !u.hasClass(p.elementClass) ||
                        u.hasClass(p.loadedClass) ||
                        u.hasClass(p.loadingClass) ||
                        (t = t.add(u[0])), 0 !== t.length &&
                        t.each(function(e, t) {
                            var a = C(t);
                            a.addClass(p.loadingClass);
                            var s = a.attr('data-background'),
                                n = a.attr('data-src'),
                                r = a.attr('data-srcset'),
                                o = a.attr('data-sizes');
                            d.loadImage(a[0], n || s, r, o, !1, function() {
                                if (null != d && d && (!d || d.params) && !d.destroyed) {
                                    if (
                                        (
                                            s
                                                ? (
                                                      a.css(
                                                          'background-image',
                                                          'url("' + s + '")'
                                                      ),
                                                      a.removeAttr('data-background')
                                                  )
                                                : (
                                                      r &&
                                                          (
                                                              a.attr('srcset', r),
                                                              a.removeAttr('data-srcset')
                                                          ),
                                                      o &&
                                                          (
                                                              a.attr('sizes', o),
                                                              a.removeAttr('data-sizes')
                                                          ),
                                                      n &&
                                                          (
                                                              a.attr('src', n),
                                                              a.removeAttr('data-src')
                                                          )
                                                  ),
                                            a
                                                .addClass(p.loadedClass)
                                                .removeClass(p.loadingClass),
                                            u.find('.' + p.preloaderClass).remove(),
                                            d.params.loop && l
                                        )
                                    ) {
                                        var e = u.attr('data-swiper-slide-index');
                                        if (u.hasClass(d.params.slideDuplicateClass)) {
                                            var t = d.$wrapperEl.children(
                                                '[data-swiper-slide-index="' +
                                                    e +
                                                    '"]:not(.' +
                                                    d.params.slideDuplicateClass +
                                                    ')'
                                            );
                                            d.lazy.loadInSlide(t.index(), !1);
                                        } else {
                                            var i = d.$wrapperEl.children(
                                                '.' +
                                                    d.params.slideDuplicateClass +
                                                    '[data-swiper-slide-index="' +
                                                    e +
                                                    '"]'
                                            );
                                            d.lazy.loadInSlide(i.index(), !1);
                                        }
                                    }
                                    d.emit('lazyImageReady', u[0], a[0]);
                                }
                            }), d.emit('lazyImageLoad', u[0], a[0]);
                        });
                }
            },
            load: function() {
                var a = this,
                    t = a.$wrapperEl,
                    i = a.params,
                    s = a.slides,
                    e = a.activeIndex,
                    n = a.virtual && i.virtual.enabled,
                    r = i.lazy,
                    o = i.slidesPerView;
                function l(e) {
                    if (n) {
                        if (
                            t.children(
                                '.' +
                                    i.slideClass +
                                    '[data-swiper-slide-index="' +
                                    e +
                                    '"]'
                            ).length
                        )
                            return !0;
                    } else if (s[e]) return !0;
                    return !1;
                }
                function d(e) {
                    return n ? C(e).attr('data-swiper-slide-index') : C(e).index();
                }
                if (
                    (
                        'auto' === o && (o = 0),
                        a.lazy.initialImageLoaded || (a.lazy.initialImageLoaded = !0),
                        a.params.watchSlidesVisibility
                    )
                )
                    t.children('.' + i.slideVisibleClass).each(function(e, t) {
                        var i = n ? C(t).attr('data-swiper-slide-index') : C(t).index();
                        a.lazy.loadInSlide(i);
                    });
                else if (1 < o)
                    for (var p = e; p < e + o; p += 1) l(p) && a.lazy.loadInSlide(p);
                else a.lazy.loadInSlide(e);
                if (r.loadPrevNext)
                    if (1 < o || (r.loadPrevNextAmount && 1 < r.loadPrevNextAmount)) {
                        for (
                            var u = r.loadPrevNextAmount,
                                c = o,
                                h = Math.min(e + c + Math.max(u, c), s.length),
                                v = Math.max(e - Math.max(c, u), 0),
                                f = e + o;
                            f < h;
                            f += 1
                        )
                            l(f) && a.lazy.loadInSlide(f);
                        for (var m = v; m < e; m += 1) l(m) && a.lazy.loadInSlide(m);
                    } else {
                        var g = t.children('.' + i.slideNextClass);
                        0 < g.length && a.lazy.loadInSlide(d(g));
                        var w = t.children('.' + i.slidePrevClass);
                        0 < w.length && a.lazy.loadInSlide(d(w));
                    }
            }
        },
        D = {
            run: function() {
                var e = this,
                    t = e.slides.eq(e.activeIndex),
                    i = e.params.autoplay.delay;
                t.attr('data-swiper-autoplay') &&
                    (i =
                        t.attr('data-swiper-autoplay') ||
                        e.params.autoplay.delay), clearTimeout(
                    e.autoplay.timeout
                ), (e.autoplay.timeout = ee.nextTick(function() {
                    e.params.autoplay.reverseDirection
                        ? e.params.loop
                          ? (
                                e.loopFix(),
                                e.slidePrev(e.params.speed, !0, !0),
                                e.emit('autoplay')
                            )
                          : e.isBeginning
                            ? e.params.autoplay.stopOnLastSlide
                              ? e.autoplay.stop()
                              : (
                                    e.slideTo(
                                        e.slides.length - 1,
                                        e.params.speed,
                                        !0,
                                        !0
                                    ),
                                    e.emit('autoplay')
                                )
                            : (e.slidePrev(e.params.speed, !0, !0), e.emit('autoplay'))
                        : e.params.loop
                          ? (
                                e.loopFix(),
                                e.slideNext(e.params.speed, !0, !0),
                                e.emit('autoplay')
                            )
                          : e.isEnd
                            ? e.params.autoplay.stopOnLastSlide
                              ? e.autoplay.stop()
                              : (e.slideTo(0, e.params.speed, !0, !0), e.emit('autoplay'))
                            : (e.slideNext(e.params.speed, !0, !0), e.emit('autoplay'));
                }, i));
            },
            start: function() {
                var e = this;
                return (
                    void 0 === e.autoplay.timeout &&
                    (!e.autoplay.running &&
                        (
                            (e.autoplay.running = !0),
                            e.emit('autoplayStart'),
                            e.autoplay.run(),
                            !0
                        ))
                );
            },
            stop: function() {
                var e = this;
                return (
                    !!e.autoplay.running &&
                    (void 0 !== e.autoplay.timeout &&
                        (
                            e.autoplay.timeout &&
                                (
                                    clearTimeout(e.autoplay.timeout),
                                    (e.autoplay.timeout = void 0)
                                ),
                            (e.autoplay.running = !1),
                            e.emit('autoplayStop'),
                            !0
                        ))
                );
            },
            pause: function(e) {
                var t = this;
                t.autoplay.running &&
                    (t.autoplay.paused ||
                        (
                            t.autoplay.timeout && clearTimeout(t.autoplay.timeout),
                            (t.autoplay.paused = !0),
                            0 !== e && t.params.autoplay.waitForTransition
                                ? (
                                      t.$wrapperEl[0].addEventListener(
                                          'transitionend',
                                          t.autoplay.onTransitionEnd
                                      ),
                                      t.$wrapperEl[0].addEventListener(
                                          'webkitTransitionEnd',
                                          t.autoplay.onTransitionEnd
                                      )
                                  )
                                : ((t.autoplay.paused = !1), t.autoplay.run())
                        ));
            }
        },
        A = {
            setTranslate: function() {
                for (var e = this, t = e.slides, i = 0; i < t.length; i += 1) {
                    var a = e.slides.eq(i),
                        s = -a[0].swiperSlideOffset;
                    e.params.virtualTranslate || (s -= e.translate);
                    var n = 0;
                    e.isHorizontal() || ((n = s), (s = 0));
                    var r = e.params.fadeEffect.crossFade
                        ? Math.max(1 - Math.abs(a[0].progress), 0)
                        : 1 + Math.min(Math.max(a[0].progress, -1), 0);
                    a
                        .css({ opacity: r })
                        .transform('translate3d(' + s + 'px, ' + n + 'px, 0px)');
                }
            },
            setTransition: function(e) {
                var i = this,
                    t = i.slides,
                    a = i.$wrapperEl;
                if ((t.transition(e), i.params.virtualTranslate && 0 !== e)) {
                    var s = !1;
                    t.transitionEnd(function() {
                        if (!s && i && !i.destroyed) {
                            (s = !0), (i.animating = !1);
                            for (
                                var e = ['webkitTransitionEnd', 'transitionend'], t = 0;
                                t < e.length;
                                t += 1
                            )
                                a.trigger(e[t]);
                        }
                    });
                }
            }
        },
        B = [
            E,
            M,
            P,
            k,
            {
                name: 'observer',
                params: { observer: !1, observeParents: !1, observeSlideChildren: !1 },
                create: function() {
                    ee.extend(this, {
                        observer: {
                            init: L.init.bind(this),
                            attach: L.attach.bind(this),
                            destroy: L.destroy.bind(this),
                            observers: []
                        }
                    });
                },
                on: {
                    init: function() {
                        this.observer.init();
                    },
                    destroy: function() {
                        this.observer.destroy();
                    }
                }
            },
            {
                name: 'navigation',
                params: {
                    navigation: {
                        nextEl: null,
                        prevEl: null,
                        hideOnClick: !1,
                        disabledClass: 'swiper-button-disabled',
                        hiddenClass: 'swiper-button-hidden',
                        lockClass: 'swiper-button-lock'
                    }
                },
                create: function() {
                    var e = this;
                    ee.extend(e, {
                        navigation: {
                            init: z.init.bind(e),
                            update: z.update.bind(e),
                            destroy: z.destroy.bind(e),
                            onNextClick: z.onNextClick.bind(e),
                            onPrevClick: z.onPrevClick.bind(e)
                        }
                    });
                },
                on: {
                    init: function() {
                        this.navigation.init(), this.navigation.update();
                    },
                    toEdge: function() {
                        this.navigation.update();
                    },
                    fromEdge: function() {
                        this.navigation.update();
                    },
                    destroy: function() {
                        this.navigation.destroy();
                    },
                    click: function(e) {
                        var t,
                            i = this,
                            a = i.navigation,
                            s = a.$nextEl,
                            n = a.$prevEl;
                        !i.params.navigation.hideOnClick ||
                            C(e.target).is(n) ||
                            C(e.target).is(s) ||
                            (
                                s
                                    ? (t = s.hasClass(i.params.navigation.hiddenClass))
                                    : n &&
                                      (t = n.hasClass(i.params.navigation.hiddenClass)),
                                !0 === t
                                    ? i.emit('navigationShow', i)
                                    : i.emit('navigationHide', i),
                                s && s.toggleClass(i.params.navigation.hiddenClass),
                                n && n.toggleClass(i.params.navigation.hiddenClass)
                            );
                    }
                }
            },
            {
                name: 'pagination',
                params: {
                    pagination: {
                        el: null,
                        bulletElement: 'span',
                        clickable: !1,
                        hideOnClick: !1,
                        renderBullet: null,
                        renderProgressbar: null,
                        renderFraction: null,
                        renderCustom: null,
                        progressbarOpposite: !1,
                        type: 'bullets',
                        dynamicBullets: !1,
                        dynamicMainBullets: 1,
                        formatFractionCurrent: function(e) {
                            return e;
                        },
                        formatFractionTotal: function(e) {
                            return e;
                        },
                        bulletClass: 'swiper-pagination-bullet',
                        bulletActiveClass: 'swiper-pagination-bullet-active',
                        modifierClass: 'swiper-pagination-',
                        currentClass: 'swiper-pagination-current',
                        totalClass: 'swiper-pagination-total',
                        hiddenClass: 'swiper-pagination-hidden',
                        progressbarFillClass: 'swiper-pagination-progressbar-fill',
                        progressbarOppositeClass:
                            'swiper-pagination-progressbar-opposite',
                        clickableClass: 'swiper-pagination-clickable',
                        lockClass: 'swiper-pagination-lock'
                    }
                },
                create: function() {
                    var e = this;
                    ee.extend(e, {
                        pagination: {
                            init: I.init.bind(e),
                            render: I.render.bind(e),
                            update: I.update.bind(e),
                            destroy: I.destroy.bind(e),
                            dynamicBulletIndex: 0
                        }
                    });
                },
                on: {
                    init: function() {
                        this.pagination.init(), this.pagination.render(), this.pagination.update();
                    },
                    activeIndexChange: function() {
                        this.params.loop
                            ? this.pagination.update()
                            : void 0 === this.snapIndex && this.pagination.update();
                    },
                    snapIndexChange: function() {
                        this.params.loop || this.pagination.update();
                    },
                    slidesLengthChange: function() {
                        this.params.loop &&
                            (this.pagination.render(), this.pagination.update());
                    },
                    snapGridLengthChange: function() {
                        this.params.loop ||
                            (this.pagination.render(), this.pagination.update());
                    },
                    destroy: function() {
                        this.pagination.destroy();
                    },
                    click: function(e) {
                        var t = this;
                        t.params.pagination.el &&
                            t.params.pagination.hideOnClick &&
                            0 < t.pagination.$el.length &&
                            !C(e.target).hasClass(t.params.pagination.bulletClass) &&
                            (
                                !0 ===
                                t.pagination.$el.hasClass(t.params.pagination.hiddenClass)
                                    ? t.emit('paginationShow', t)
                                    : t.emit('paginationHide', t),
                                t.pagination.$el.toggleClass(
                                    t.params.pagination.hiddenClass
                                )
                            );
                    }
                }
            },
            {
                name: 'lazy',
                params: {
                    lazy: {
                        enabled: !1,
                        loadPrevNext: !1,
                        loadPrevNextAmount: 1,
                        loadOnTransitionStart: !1,
                        elementClass: 'swiper-lazy',
                        loadingClass: 'swiper-lazy-loading',
                        loadedClass: 'swiper-lazy-loaded',
                        preloaderClass: 'swiper-lazy-preloader'
                    }
                },
                create: function() {
                    ee.extend(this, {
                        lazy: {
                            initialImageLoaded: !1,
                            load: O.load.bind(this),
                            loadInSlide: O.loadInSlide.bind(this)
                        }
                    });
                },
                on: {
                    beforeInit: function() {
                        this.params.lazy.enabled &&
                            this.params.preloadImages &&
                            (this.params.preloadImages = !1);
                    },
                    init: function() {
                        this.params.lazy.enabled &&
                            !this.params.loop &&
                            0 === this.params.initialSlide &&
                            this.lazy.load();
                    },
                    scroll: function() {
                        this.params.freeMode &&
                            !this.params.freeModeSticky &&
                            this.lazy.load();
                    },
                    resize: function() {
                        this.params.lazy.enabled && this.lazy.load();
                    },
                    scrollbarDragMove: function() {
                        this.params.lazy.enabled && this.lazy.load();
                    },
                    transitionStart: function() {
                        var e = this;
                        e.params.lazy.enabled &&
                            ((!e.params.lazy.loadOnTransitionStart &&
                                (e.params.lazy.loadOnTransitionStart ||
                                    e.lazy.initialImageLoaded)) ||
                                e.lazy.load());
                    },
                    transitionEnd: function() {
                        this.params.lazy.enabled &&
                            !this.params.lazy.loadOnTransitionStart &&
                            this.lazy.load();
                    }
                }
            },
            {
                name: 'autoplay',
                params: {
                    autoplay: {
                        enabled: !1,
                        delay: 3e3,
                        waitForTransition: !0,
                        disableOnInteraction: !0,
                        stopOnLastSlide: !1,
                        reverseDirection: !1
                    }
                },
                create: function() {
                    var t = this;
                    ee.extend(t, {
                        autoplay: {
                            running: !1,
                            paused: !1,
                            run: D.run.bind(t),
                            start: D.start.bind(t),
                            stop: D.stop.bind(t),
                            pause: D.pause.bind(t),
                            onTransitionEnd: function(e) {
                                t &&
                                    !t.destroyed &&
                                    t.$wrapperEl &&
                                    e.target === this &&
                                    (
                                        t.$wrapperEl[0].removeEventListener(
                                            'transitionend',
                                            t.autoplay.onTransitionEnd
                                        ),
                                        t.$wrapperEl[0].removeEventListener(
                                            'webkitTransitionEnd',
                                            t.autoplay.onTransitionEnd
                                        ),
                                        (t.autoplay.paused = !1),
                                        t.autoplay.running
                                            ? t.autoplay.run()
                                            : t.autoplay.stop()
                                    );
                            }
                        }
                    });
                },
                on: {
                    init: function() {
                        this.params.autoplay.enabled && this.autoplay.start();
                    },
                    beforeTransitionStart: function(e, t) {
                        this.autoplay.running &&
                            (t || !this.params.autoplay.disableOnInteraction
                                ? this.autoplay.pause(e)
                                : this.autoplay.stop());
                    },
                    sliderFirstMove: function() {
                        this.autoplay.running &&
                            (this.params.autoplay.disableOnInteraction
                                ? this.autoplay.stop()
                                : this.autoplay.pause());
                    },
                    destroy: function() {
                        this.autoplay.running && this.autoplay.stop();
                    }
                }
            },
            {
                name: 'effect-fade',
                params: { fadeEffect: { crossFade: !1 } },
                create: function() {
                    ee.extend(this, {
                        fadeEffect: {
                            setTranslate: A.setTranslate.bind(this),
                            setTransition: A.setTransition.bind(this)
                        }
                    });
                },
                on: {
                    beforeInit: function() {
                        var e = this;
                        if ('fade' === e.params.effect) {
                            e.classNames.push(e.params.containerModifierClass + 'fade');
                            var t = {
                                slidesPerView: 1,
                                slidesPerColumn: 1,
                                slidesPerGroup: 1,
                                watchSlidesProgress: !0,
                                spaceBetween: 0,
                                virtualTranslate: !0
                            };
                            ee.extend(e.params, t), ee.extend(e.originalParams, t);
                        }
                    },
                    setTranslate: function() {
                        'fade' === this.params.effect && this.fadeEffect.setTranslate();
                    },
                    setTransition: function(e) {
                        'fade' === this.params.effect && this.fadeEffect.setTransition(e);
                    }
                }
            }
        ];
    return void 0 === S.use &&
        ((S.use = S.Class.use), (S.installModule = S.Class.installModule)), S.use(B), S;
});
//# sourceMappingURL=swiper.min.js.map
